import React, { useEffect, useState, useRef } from "react";
import "./account.scss";
import {
  Button,
  Card,
  Row,
  Col,
  message,
  Form,
  Input,
  Select,
  AutoComplete,
  DatePicker,
  Spin,
  Modal,
  Typography,
  Popover,
} from "antd";
import * as logoutService from "../../service/logoutServices";
import { useTranslation } from "react-i18next";
import * as localStorageService from "../../service/localStorageService";
import { checkIsCountryPresent, removeUniquenessCheckForCountry } from "../../util/constantUtility";
import { LocalStorageKeys } from "../../constants/localStorageKeys";
import Notification from "../../service/notification";
import * as accountService from "../../service/accountService";
import * as otpService from "../../service/otpService";
import userProfile from "../../assets/images/Avatar.svg";
import editIcon from "../../assets/images/edit-icon.svg";
import profileIcon from "../../assets/images/user-profile-round.svg";
import uploadIcon from "../../assets/images/upload-icon.svg";
import * as masterDataService from "../../service/masterDataService";
import SearchSelect from "../../common/search-select/search-select";
import Fileupload from "../../common/fileupload/fileupload";
import Placepicker from "../../common/placepicker/placepicker";
import { useStore } from "../../store/store";
import ellipse from "../../assets/images/Ellipse.svg";
import folder from "../../assets/images/folder.svg";
import {
  DocTypes,
  OwnerType,
  EntityTypes,
} from "../../constants/commonConstants";
import dayjs from "dayjs";
import moment from "moment";
import * as documentUtility from "../../util/documentThumbUtility";
import {
  UploadOutlined,
  PlusOutlined,
  DeleteFilled,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  getMobileCountryCodeList,
  validateMobileNumber,
} from "../../util/countryWiseMobileNumberUtils";
import { CommonConstants } from "../../constants/commonConstants";
import {
  checkIsInternalSourcing,
  checkIsFleetOwner,
  checkIsSTO,
  checkIsFleetOwnerConverted,
  getLanguageByNationality,
  toTitleCase,
} from "../../util/constantUtility";
import RequestToBroker from "./components/request-to-broker";
import {
  GuestWarningContainer,
  GuestWarningModal,
} from "../../common/guest-warning-modal";
import { Tooltip } from "antd/lib";
import {
  ocrCustomFileUploadService,
  uploadDocumentV2,
} from "../../service/documentService";
import OCRFilePreviewUploader from "../../common/ocr-file-preview-uploader/ocr-file-preview-uploader";
import fileSearchGif from "../../assets/images/file-search.gif";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { BrandColors } from "../../constants/brand";

const { Text } = Typography;

const Account = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [kycForm] = Form.useForm();
  console.log(kycForm.getFieldsValue(), "kyc forms");
  // const [KycDetailsForm] = Form.useForm();
  const { user, saveUser } = useStore();
  const { isOTPRequested, updateIsOTPRequested } = useStore();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [MobileChangeForm] = Form.useForm();
  const [emailChangeForm] = Form.useForm();

  const [confirmMobileForm] = Form.useForm();
  const [uploadImageForm] = Form.useForm();
  const [frontDocs, setFrontDocs] = useState({});
  let refreshToken = localStorageService.getValue(
    LocalStorageKeys.RefreshToken
  );
  const accessToken = localStorageService.getValue(LocalStorageKeys.AuthToken);

  const [accountDetails, setAccountDetails] = useState({});
  const [detailLoader, setDetailLoader] = useState(false);
  const [profileEditStatus, setProfileEditStatus] = useState(false);
  const [saveProfileLoader, setSaveProfileLoader] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [cityOptionsWaiter, setCityOptionsWaiter] = useState(false);
  const [countriesListWaiter, setCountriesListWaiter] = useState(false);
  const [countryOptions, setCountryOptions] = useState();
  const [countries, setCountries] = useState();
  const [kycDetails, setKycDetails] = useState({});
  console.log(kycDetails, "kycdetauks");
  const [addressDetail, setAddressDetail] = useState({
    address: "",
    latitude: 0,
    longitude: 0,
  });

  // Values picked up from OCR uploads. Anything set here wins over what the
  // GET endpoints returned; anything left empty falls back to those.
  const [ocrDetails, setOcrDetails] = useState({
    dateOfBirth: null,
    nationality: "",
    issuingCountry: "",
    issueDate: null,
    address: "",
    nameInOtherLang: "",
  });

  // Normalize an OCR date to the payload format, null when absent/invalid
  const formatOcrDate = (value) => {
    if (!value) return null;
    const parsed = moment(
      value,
      ["DD-MM-YYYY", "YYYY-MM-DD", moment.ISO_8601],
      true
    );
    return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
  };

  // OCR text as a safe string — "" when the key is missing, null or not text
  const formatOcrText = (value) =>
    typeof value === "string" ? value.trim() : "";

  // Which documents these fields may be read from: personal documents for a
  // single truck owner, the trade/VAT document for everyone else
  const ocrSourceDocTypes = checkIsSTO(user?.userRole)
    ? ["NATIONAL_ID", "DRIVING_LICENSE"]
    : ["VAT_CERTIFICATE"];

  // Merges in whatever a single OCR document carried, keeping earlier values
  // when a later document has nothing for that field
  const captureOcrDetails = (doc) => {
    if (!doc || !ocrSourceDocTypes.includes(doc.docType)) return;

    setOcrDetails((prev) => ({
      ...prev,
      dateOfBirth: formatOcrDate(doc.birthDate) ?? prev.dateOfBirth,
      nationality: doc.nationality
        ? toTitleCase(doc.nationality.trim())
        : prev.nationality,
      address: doc.address ? doc.address : prev.address,
      issuingCountry: doc.issueCountry
        ? toTitleCase(doc.issueCountry)
        : prev.issuingCountry,
      issueDate: formatOcrDate(doc.docIssueDate) ?? prev.issueDate,
      // Kept verbatim (not title cased, it is usually non-latin script).
      // Missing on this document, so keep whatever an earlier one carried.
      nameInOtherLang:
        formatOcrText(doc.nameInOtherLang) || prev.nameInOtherLang,
    }));
  };
  const [mobileCountryCodeList, setMobileCountryCodeList] = useState([]);
  const [mobileCountryCodeLoader, setMobileCountryCodeLoader] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] =
    useState("DriverLicense");
  const [kycFormValues, setKycFormValues] = useState({});
  console.log("accounts kycFormValues", kycFormValues);

  const [userRole, setUserRole] = useState(user?.userRole);
  const [showChangeText, setShowChangeText] = useState(true);
  const [showChangeTextMobile, setShowChangeTextMobile] = useState(true);
  const emailInputRef = useRef(null);
  const mobileInputRef = useRef(null);
  const [userRoleObj, setUserRoleObj] = useState("");
  const [userDetailLoader, setUserDetailLoader] = useState(true);
  const [kycDetailLoader, setKycDetailLoader] = useState(true);
  const [saveKycDetailLoader, setSaveKycDetailLoader] = useState(false);
  const documents = [
    { type: "DriverLicense" },
    { type: "Visa" },
    { type: "Passport" },
    { type: "NationalID" },
  ];
  const [timer, setTimer] = useState(120);
  const [isChangeMobileVisible, setIsChangeMobileVisible] = useState(false);
  const [minLength, setMinLength] = useState(7);
  const [maxLength, setMaxLength] = useState(11);
  const [requestLoader, setRequestLoader] = useState(false);
  const [userExists, setUserExists] = useState(false);
  const [otpDetails, setOtpDetails] = useState();
  const [otpLoader, setOtpLoader] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [oldOtp, setIsOldOtp] = useState(false);
  const [isOldOTPVerified, setIsOldOTPVerified] = useState(true);
  const [isNewOTPRequested, setNewOTPRequested] = useState(false);
  const [showEmail, setIsShowEmail] = useState(false);
  const [addEmailModal, setaddEmailModal] = useState(false);
  const [emailOtpLoader, setemailOtpLoader] = useState(true);
  const [ibanNumber, setIbanNumber] = useState([]);
  const [isUploadImage, setIsUploadImage] = useState(false);
  const [imageUploadLoader, setImageUploadLoader] = useState(false);
  const [isAddEmailOtpVerified, setisAddEmailOtpVerified] = useState(false);
  const [addEmailOtpLoader, setAddEmailOtpLoader] = useState(false);
  let isGuest = localStorageService.getValue("guestMode") === "true";
  const language = localStorageService.getValue(LocalStorageKeys.Lang)
    ? localStorageService.getValue(LocalStorageKeys.Lang)
    : CommonConstants.DefaultLanguageCode;
  const [confirmMobileData, setconfirmMobileData] = useState({
    countryCode: "",
    mobileNumber: "",
    otpNumber: "",
    countryCodeName: "",
    countryName: "",
  });
  const format = "DD/MM/YYYY";

  const defaultVisaDoc = {
    index: 0,
    documentNumber: "",
    expiryDate: "",
    frontDoc: {
      isInsertUpdate: false,
      isPathSet: true,
      documentPath: "",
      documentPathThumb: "",
      fileName: "",
    },
  };
  const [visa, setVisa] = useState([
    {
      index: 0,
      associateId: "",
      documentNumber: "",
      expiryDate: "",
      issuingCountry: "",
      document: [
        {
          isInsertUpdate: false,
          isPathSet: true,
          documentPath: "",
          documentPathThumb: "",
          fileName: "",
        },
      ],
      frontDoc: {
        documentPath: "",
        documentPathThumb: "",
        fileName: "",
        isInsertUpdate: false,
        isPathSet: true,
      },
    },
  ]);
  console.log("accounts visa", visa);
  // console.log(kycForm.getFieldsValue(),'formdaa')
  const isTurkeyKazakhstanPresent =
    user?.operatingCountry === "Turkey" ||
    user?.operatingCountry === "Kazakhstan" ||
    !checkIsCountryPresent(user?.operatingCountry);

  // ******************* OCR File Uploads STATES *****************
  const initialUploadState = {
    progress: 0,
    status: t("OCR_MODAL_HOLD_TIGHT_MSG"),
    description: "Please don’t close or refresh the screen",
    started: false,
  };

  // const ownerType = detailData?.userRole || null;
  const ownerType = userRole || null;
  console.log("accounts ownerType", ownerType);
  const [ocrLogId, setOcrLogId] = useState("");
  const [isOcrFileUpload, setIsOcrFileUpload] = useState(false);
  const [ocrParsedData, setOcrParsedData] = useState(null);
  const [isUploadingPopupVisible, setIsUploadingPopupVisible] = useState(false);
  const [uploadState, setUploadState] = useState(initialUploadState);
  console.log("accounts uploadState", uploadState);
  const [editAccoutDocs, setEditAccountDocs] = useState();
  console.log("accounts editAccoutDocs", editAccoutDocs);

  useEffect(() => {
    const length = kycDetails?.iBanNo?.length || 1;
    if (kycDetails?.iBanNo?.length > 0) {
      setIbanNumber(kycDetails?.iBanNo);
    } else {
      setIbanNumber(Array.from({ length }, () => ""));
    }
  }, [kycDetails?.iBanNo]);

  useEffect(() => {
    if (!isGuest) {
      getCountries();
      getCountryMobileCodeMaster();
      getAccountDetails();
      getSupplierKycInfo();
      // getSupplierKycInfo();
    }
  }, []);

  useEffect(() => {
    if (isChangeMobileVisible) {
      sendOldNumberOtp();
    } else if (showEmail && accountDetails?.email) {
      onRequestOtpEmali();
    }
  }, [isChangeMobileVisible, showEmail]);

  useEffect(() => {
    let interval;
    if (isOTPRequested && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    if (timer === 0) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isOTPRequested, timer]);

  const getCountryWiseValidation = (countryCode) => {
    switch (countryCode) {
      case "+971":
      case "+966":
      case "+962":
      case "+48":
        setMinLength(9);
        setMaxLength(9);
        break;
      case "+968":
      case "+973":
        setMinLength(8);
        setMaxLength(8);
        break;
      case "+20":
      case "+91":
        setMinLength(10);
        setMaxLength(10);
        break;
      case "+965":
      case "+967":
        setMinLength(8);
        setMaxLength(9);
        break;
      case "+90":
        setMinLength(7);
        setMaxLength(11);
        break;
      case "+86":
        setMinLength(11);
        setMaxLength(11);
        break;
      case "+7":
        setMinLength(9);
        setMaxLength(11);
        break;
      default:
        setMinLength(7);
        setMaxLength(11);
        break;
    }
  };

  const onClickProfileEdit = () => {
    setProfileEditStatus(true);
    form.setFieldValue(
      "countryCode",
      accountDetails?.countryCode ? accountDetails?.countryCode : null
    );
  };
  const getCountries = () => {
    setCountriesListWaiter(true);
    masterDataService
      .getCountryMaster()
      .then((res) => {
        setCountriesListWaiter(false);
        if (res.status === 200) {
          setCountryOptions(res.data);
          const filterCityObj = res?.data?.find(
            (e) => e.name === user?.operatingCountry
          );
          getCityList(filterCityObj?.country_code);
        }
      })
      .catch((err) => {
        setCountriesListWaiter(false);
      });
  };

  const getCountryMobileCodeMaster = async (countryCode = "") => {
    setMobileCountryCodeLoader(true);
    try {
      const response = await masterDataService.getCountryMobileCodeMaster(
        countryCode,
        true
      );
      if (response.status === 200) {
        setMobileCountryCodeList(getMobileCountryCodeList(response.data, true));
      }
      setMobileCountryCodeLoader(false);
    } catch (error) {
      setMobileCountryCodeLoader(false);
    }
  };

  const [userProfilePicture, setUserProfilePicture] = useState(null);

  const getAccountDetails = () => {
    setAccountDetails({});
    setUserDetailLoader(true);
    accountService
      .getAccountDetails(user?.userId)
      .then((response) => {
        setUserDetailLoader(false);
        //setAccountDetails(response?.data?.data);
        fillUserDetail(response);
        let result = response?.data?.data;
        if (response.data.data.profilePicture) {
          const formData = {
            uploadImage: {
              docType: DocTypes.PROFILE_PIC,
              fileName: result?.profilePicture?.fileName,
              fileUrl: result?.profilePicture?.documentPath,
              fileThumbUrl: result?.profilePicture?.documentPathThumb,
            },
          };
          uploadImageForm.setFieldsValue(formData);
          setUserProfilePicture(result?.profilePicture?.documentPath);
        }
      })

      .catch((error) => {
        setDetailLoader(false);
      });
  };

  const fillUserDetail = (response) => {
    let res = response?.data?.data;
    setAccountDetails({
      fullName: res?.name ? res?.name : "",
      mobileNo: res?.mobileNo ? res?.mobileNo : "",
      country: res?.country ? res?.country : "",
      city: res?.city ? res?.city : "",
      countryCode: res?.countryCode ? res?.countryCode : "",
      email: res?.emailId ? res?.emailId : "",
      userRole: res?.userRole ? res?.userRole : "",
      address: res?.address ? res?.address : "",
      userKycStatus: res?.userKycStatus ? res?.userKycStatus : "",
      isSTOConvertedInBroker: res?.isSTOConvertedInBroker ? true : false,
      dateOfBirth:res?.dateOfBirth ? res?.dateOfBirth : null,
      nationality:res?.nationality ? res?.nationality : "",
      issuingCountry:res?.issuingCountry ? res?.issuingCountry : "",
      issueDate:res?.issueDate ? res?.issueDate : null,
      preferredLanguage:res?.defaultLanguage ? res?.defaultLanguage : null,
      defaultLanguage:res?.defaultLanguage ? res?.defaultLanguage : null,
      address1: res?.address ? res?.address : "",
      address2: res?.address?.location ? res?.address?.location : "",
      baseCountry:res?.country ? res?.country : "",
      PrefCommunicationLaguage:res?.defaultLanguage ? res?.defaultLanguage : null,
      CommunicationPreference:CommonConstants.CommunicationPreference
    });
    form.setFieldsValue({
      fullName: res?.name,
      city: res?.city,
      email: res?.emailId,
      mobileNo: res?.mobileNo,
      country: res?.country,
      countryCode: res?.countryCode,
      address: res?.address,
    });
  };

  const getSupplierKycInfo = () => {
    setKycDetails({});
    setKycDetailLoader(true);
    accountService
      .getSupplierKycInfo(user?.userId)
      .then((response) => {
        let result = response?.data?.data;

        let editFormValues;
        if (
          userRole == OwnerType.FLEET_OWNER ||
          userRole == OwnerType.FLEET_OWNER_C
        ) {
          editFormValues = {
            // vat reg details
            vatNumber: result?.vatCertificate?.documentNumber,
            vatExpiry: result?.vatCertificate?.expiryDate
              ? moment(result?.vatCertificate?.expiryDate).format(format)
              : null,
            vatUpload: {
              fileName: result?.vatCertificate?.frontDoc?.fileName,
              fileUrl: result?.vatCertificate?.frontDoc?.documentPath,
              fileThumbUrl: result?.vatCertificate?.frontDoc?.documentPathThumb,
              isInsertUpdate: false,
            },

            //trade details
            tradeLicenseNumber: result?.tradeLicense?.documentNumber,
            tradeExpiry: result?.tradeLicense?.expiryDate
              ? moment(result?.tradeLicense?.expiryDate).format(format)
              : null,
            tradeLicenseUpload: {
              fileName: result?.tradeLicense?.frontDoc?.fileName,
              fileUrl: result?.tradeLicense?.frontDoc?.documentPath,
              fileThumbUrl: result?.tradeLicense?.frontDoc?.documentPathThumb,
              isInsertUpdate: false,
            },
            iBanNo: [...(result?.iBanNo || [])],
            registrationOffice: result?.registrationOffice,
            certification:
              result?.certification?.length > 0 ? result?.certification[0] : "",
          };
        } else {
          editFormValues = {
            //driving licence
            driverLicenseNumber: result?.drivingLicense?.documentNumber,
            driverExpiry: result?.drivingLicense?.expiryDate
              ? moment(result?.drivingLicense?.expiryDate).format(format)
              : null,
            licenceFront: {
              fileName: result?.drivingLicense?.frontDoc?.fileName,
              fileUrl: result?.drivingLicense?.frontDoc?.documentPath,
              fileThumbUrl: result?.drivingLicense?.frontDoc?.documentPathThumb,
              isInsertUpdate: false,
            },
            licenceBack: {
              fileName: result?.drivingLicense?.backDoc?.fileName,
              fileUrl: result?.drivingLicense?.backDoc?.documentPath,
              fileThumbUrl: result?.drivingLicense?.backDoc?.documentPathThumb,
              isInsertUpdate: false,
            },
            //passport
            passportNumber: result?.passport?.documentNumber,
            passportExpiry: result?.passport?.expiryDate
              ? moment(result?.passport?.expiryDate).format(format)
              : null,
            passportFront: {
              fileName: result?.passport?.frontDoc?.fileName,
              fileUrl: result?.passport?.frontDoc?.documentPath,
              fileThumbUrl: result?.passport?.frontDoc?.documentPathThumb,
              isInsertUpdate: false,
            },
            passportBack: {
              fileName: result?.passport?.backDoc?.fileName,
              fileUrl: result?.passport?.backDoc?.documentPath,
              fileThumbUrl: result?.passport?.backDoc?.documentPathThumb,
              isInsertUpdate: false,
            },
            //national id
            nationalIDNumber: result?.nationalID?.documentNumber,
            nationalIDExpiry: result?.nationalID?.expiryDate
              ? moment(result?.nationalID?.expiryDate).format(format)
              : "",
            nationalIdFront: {
              fileName: result?.nationalID?.frontDoc?.fileName,
              fileUrl: result?.nationalID?.frontDoc?.documentPath,
              fileThumbUrl: result?.nationalID?.frontDoc?.documentPathThumb,
              isInsertUpdate: false,
            },
            nationalIdBack: {
              fileName: result?.nationalID?.backDoc?.fileName,
              fileUrl: result?.nationalID?.backDoc?.documentPath,
              fileThumbUrl: result?.nationalID?.backDoc?.documentPathThumb,
              isInsertUpdate: false,
            },

            //visa documents
            visa: result?.visa?.length ? result?.visa : visa,
            // visa: result?.visa?.map((visa) => ({
            //   visaNumber: visa?.documentNumber || "",
            //   visaExpiry: visa?.expiryDate ? moment(visa?.expiryDate).format(format) : null,
            //   frontDoc: {
            //     fileName: visa?.frontDoc?.fileName || "",
            //     fileUrl: visa?.frontDoc?.documentPath || "",
            //     fileThumbUrl: visa?.frontDoc?.documentPathThumb || "",
            //   }
            // })),
          };
        }

        const formattedVisa =
          editFormValues?.visa?.map((val) => ({
            ...val,
            expiryDate: val?.expiryDate
              ? moment(val?.expiryDate).format(format)
              : null,
            // frontDoc: {
            //   ...val.frontDoc,
            //   isInsertUpdate: false,
            //   isPathSet: true
            // }
          })) || [];
        setVisa(formattedVisa);
        console.log(editFormValues, "editformvalue");
        kycForm.setFieldsValue(editFormValues);

        setKycFormValues(editFormValues);
        setKycDetails(response?.data?.data);
        setKycDetailLoader(false);
        // countDocument(response?.data?.data);
      })
      .catch((error) => {
        setKycDetailLoader(false);
      });
  };

  const saveProfileDetails = () => {
    const profileValues = uploadImageForm.getFieldValue("uploadImage");
    setSaveProfileLoader(true);

    // OCR nationality wins, then whatever the GET returned, then the country.
    // The language follows a fresh OCR nationality, otherwise it is left as is.
    const profileNationality =
      ocrDetails?.nationality ||
      accountDetails?.nationality ||
      accountDetails?.country ||
      "";
    const profileLanguage = ocrDetails?.nationality
      ? getLanguageByNationality(ocrDetails.nationality)
      : accountDetails?.defaultLanguage ||
        getLanguageByNationality(profileNationality);

    form
      .validateFields()
      .then(() => {
        let payload = {
          userRole: accountDetails?.userRole ? accountDetails?.userRole : "",
          countryCode: accountDetails?.countryCode
            ? accountDetails?.countryCode
            : "",
          mobileNo: accountDetails?.mobileNo ? accountDetails?.mobileNo : "",
          name: accountDetails?.fullName ? accountDetails?.fullName : "",

          email: accountDetails?.email ? accountDetails?.email : "",
          country: accountDetails?.country ? accountDetails?.country : "",
          city: accountDetails?.city ? accountDetails?.city : "",
          address: {
            location: accountDetails?.address?.location
              ? accountDetails?.address?.location
              : "Dubai",
            longitude: accountDetails?.address?.longitude
              ? accountDetails?.address?.longitude
              : 0,
            latitude: accountDetails?.address?.latitude
              ? accountDetails?.address?.latitude
              : 0,
          },
          profilePicture: profileValues
            ? {
                isInsertUpdate: true,
                documentPath: profileValues?.fileUrl
                  ? profileValues?.fileUrl
                  : null,
                documentPathThumb: profileValues?.fileThumbUrl
                  ? profileValues?.fileThumbUrl
                  : null,
                fileName: profileValues?.fileName
                  ? profileValues?.fileName
                  : null,
                isPathSet: true,
              }
            : null,
          // OCR wins where it read something, otherwise keep what the GET gave us
          dateOfBirth: ocrDetails?.dateOfBirth || accountDetails?.dateOfBirth || null,
          nationality: profileNationality,
          issuingCountry: ocrDetails?.issuingCountry || accountDetails?.issuingCountry || "",
          issueDate: ocrDetails?.issueDate || accountDetails?.issueDate || null,
          localLagEntityName:
            ocrDetails?.nameInOtherLang ||
            accountDetails?.localLagEntityName ||
            "",
          preferredLanguage: profileLanguage,
          defaultLanguage: profileLanguage,
          address1: {
            location:
              ocrDetails?.address || accountDetails?.address?.location || "Dubai",
            longitude: ocrDetails?.address
              ? 0
              : accountDetails?.address?.longitude || 0,
            latitude: ocrDetails?.address
              ? 0
              : accountDetails?.address?.latitude || 0,
          },
          address2:
            ocrDetails?.address || accountDetails?.address?.location || null,
          baseCountry:accountDetails?.country ? accountDetails?.country : "",
          PrefCommunicationLaguage: profileLanguage,
          communicationPreference:CommonConstants.CommunicationPreference
        };
        accountService
          .saveProfileDetails(payload)
          .then((response) => {
            setSaveProfileLoader(false);
            setProfileEditStatus(true);
            Notification.success(
              t("USER_DETAIL_KEY"),
              t("USER_DETAILS_SUCCESS")
            );
            setAccountDetails(response?.data?.data);
            getAccountDetails();
            // fillUserDetail(response);
          })
          .catch((error) => {
            setSaveProfileLoader(false);
          });
      })
      .catch(() => {
        setSaveProfileLoader(false);
      });
  };

  const saveProfileDetailsKYC = () => {
    setSaveKycDetailLoader(true);
    kycForm
      .validateFields()
      .then(() => {
        let payload;
        const values = kycForm.getFieldsValue();

        if (
          accountDetails?.userRole == OwnerType.FLEET_OWNER ||
          accountDetails?.userRole == OwnerType.FLEET_OWNER_C
        ) {
          payload = {
            ...(isTurkeyKazakhstanPresent
              ? user?.operatingCountry === "Kazakhstan"
                ? {
                    tradeLicense: {
                      documentNumber: values?.tradeLicenseNumber,
                      expiryDate: values?.tradeExpiry
                        ? moment(values?.tradeExpiry, format).format(
                            "YYYY-MM-DD"
                          )
                        : null,
                      frontDoc: {
                        isInsertUpdate:
                          values?.tradeLicenseUpload?.isInsertUpdate,
                        documentPath: values?.tradeLicenseUpload?.fileUrl,
                        documentPathThumb:
                          values?.tradeLicenseUpload?.fileThumbUrl,
                        fileName: values?.tradeLicenseUpload?.fileName,
                        isPathSet: true,
                      },
                    },
                  }
                : {
                    vatCertificate: {
                      documentNumber: values?.vatNumber,
                      expiryDate: values?.vatExpiry
                        ? moment(values?.vatExpiry, format).format("YYYY-MM-DD")
                        : null,
                      // issueDate:"",
                      frontDoc: {
                        isInsertUpdate: values?.vatUpload?.isInsertUpdate,
                        documentPath: values?.vatUpload?.fileUrl,
                        documentPathThumb: values?.vatUpload?.fileThumbUrl,
                        fileName: values?.vatUpload?.fileName,
                        isPathSet: true,
                      },
                    },
                  }
              : {
                  vatCertificate: {
                    documentNumber: values?.vatNumber,
                    expiryDate: values?.vatExpiry
                      ? moment(values?.vatExpiry, format).format("YYYY-MM-DD")
                      : null,
                    // issueDate:"",
                    frontDoc: {
                      isInsertUpdate: values?.vatUpload?.isInsertUpdate,
                      documentPath: values?.vatUpload?.fileUrl,
                      documentPathThumb: values?.vatUpload?.fileThumbUrl,
                      fileName: values?.vatUpload?.fileName,
                      isPathSet: true,
                    },
                  },
                }),
            ...(isTurkeyKazakhstanPresent
              ? {
                  certification: [values?.certification],
                  iBanNo: ibanNumber,
                  registrationOffice: values?.registrationOffice,
                }
              : {
                  tradeLicense: {
                    documentNumber: values?.tradeLicenseNumber,
                    expiryDate: values?.tradeExpiry
                      ? moment(values?.tradeExpiry, format).format("YYYY-MM-DD")
                      : null,
                    frontDoc: {
                      isInsertUpdate:
                        values?.tradeLicenseUpload?.isInsertUpdate,
                      documentPath: values?.tradeLicenseUpload?.fileUrl,
                      documentPathThumb:
                        values?.tradeLicenseUpload?.fileThumbUrl,
                      fileName: values?.tradeLicenseUpload?.fileName,
                      isPathSet: true,
                    },
                  },
                }),
          };
        } else {
          // let formatVisaPayload = visa?.map((val) => ({
          //   ...val,
          //   expiryDate: val?.expiryDate ? moment(val?.expiryDate, format).format('YYYY-MM-DD') : null,
          // }))
          // Helper function to check if visa object has any filled fields

          const hasAnyFilledFields = (visaObj) => {
            return (
              (visaObj?.documentNumber &&
                visaObj.documentNumber.trim() !== "") ||
              (visaObj?.issuingCountry &&
                visaObj.issuingCountry.trim() !== "") ||
              (visaObj?.expiryDate && visaObj.expiryDate.trim() !== "") ||
              (visaObj?.frontDoc?.fileName &&
                visaObj.frontDoc.fileName.trim() !== "") ||
              (visaObj?.frontDoc?.documentPath &&
                visaObj.frontDoc.documentPath.trim() !== "")
            );
          };
          let formatVisaPayload =
            visa
              ?.map((val) => ({
                ...val,
                documentNumber: val?.documentNumber ? val.documentNumber : null,
                frontDoc: {
                  isInsertUpdate: val?.frontDoc?.fileName
                    ? val?.frontDoc?.isInsertUpdate
                    : false,
                  isPathSet: true,
                  documentPath: val?.frontDoc?.documentPath || "",
                  documentPathThumb: val?.frontDoc?.documentPathThumb || "",
                  fileName: val?.frontDoc?.fileName,
                },
                expiryDate: val?.expiryDate
                  ? moment(val?.expiryDate, format, true).isValid()
                    ? moment(val?.expiryDate, format).format("YYYY-MM-DD")
                    : moment(val?.expiryDate).format("YYYY-MM-DD")
                  : null,
              }))
              .filter(hasAnyFilledFields) || [];
          payload = {
            drivingLicense: {
              documentNumber: values?.driverLicenseNumber,
              expiryDate: values?.driverExpiry
                ? moment(values?.driverExpiry, format).format("YYYY-MM-DD")
                : null,
              issuingCountry: "",
              frontDoc: {
                isInsertUpdate: values?.licenceFront?.isInsertUpdate,
                documentPath: values?.licenceFront?.fileUrl,
                documentPathThumb: values?.licenceFront?.fileThumbUrl,
                fileName: values?.licenceFront?.fileName,
                isPathSet: true,
              },
              backDoc: {
                isInsertUpdate: values?.licenceBack?.isInsertUpdate,
                documentPath: values?.licenceBack?.fileUrl,
                documentPathThumb: values?.licenceBack?.fileThumbUrl,
                fileName: values?.licenceBack?.fileName,
                isPathSet: true,
              },
            },
            passport: {
              documentNumber: values?.passportNumber,
              expiryDate: values?.passportExpiry
                ? moment(values?.passportExpiry, format).format("YYYY-MM-DD")
                : null,
              issuingCountry: "",
              frontDoc: {
                isInsertUpdate: values?.passportFront?.isInsertUpdate,
                documentPath: values?.passportFront?.fileUrl,
                documentPathThumb: values?.passportFront?.fileThumbUrl,
                fileName: values?.passportFront?.fileName,
                isPathSet: true,
              },
              backDoc: {
                isInsertUpdate: values?.passportBack?.isInsertUpdate,
                documentPath: values?.passportBack?.fileUrl,
                documentPathThumb: values?.passportBack?.fileThumbUrl,
                fileName: values?.passportBack?.fileName,
                isPathSet: true,
              },
            },
            nationalID: {
              documentNumber: values?.nationalIDNumber,
              expiryDate: values?.nationalIDExpiry
                ? moment(values?.nationalIDExpiry, format).format("YYYY-MM-DD")
                : null,
              frontDoc: {
                isInsertUpdate: values?.nationalIdFront?.isInsertUpdate,
                isPathSet: true,
                documentPath: values?.nationalIdFront?.fileUrl,
                documentPathThumb: values?.nationalIdFront?.fileThumbUrl,
                fileName: values?.nationalIdFront?.fileName,
              },
              backDoc: {
                isInsertUpdate: values?.nationalIdBack?.isInsertUpdate,
                isPathSet: true,
                documentPath: values?.nationalIdBack?.fileUrl,
                documentPathThumb: values?.nationalIdBack?.fileThumbUrl,
                fileName: values?.nationalIdBack?.fileName,
              },
            },

            visa: formatVisaPayload,
          };
        }

        // OCR nationality wins, then whatever the GET returned, then the country.
        // The language follows a fresh OCR nationality, otherwise it is left as is.
        const kycNationality =
          ocrDetails?.nationality ||
          kycDetails?.nationality ||
          accountDetails?.country ||
          "";
        const kycLanguage = ocrDetails?.nationality
          ? getLanguageByNationality(ocrDetails.nationality)
          : kycDetails?.defaultLanguage ||
            getLanguageByNationality(kycNationality);

        payload = {
            ...payload,
        // OCR wins where it read something, otherwise keep what the GET gave us
        dateOfBirth: ocrDetails?.dateOfBirth ?? kycDetails?.dateOfBirth ?? null,
        nationality: kycNationality,
        issuingCountry:
          ocrDetails?.issuingCountry || kycDetails?.issuingCountry || "",
        issueDate: ocrDetails?.issueDate ?? kycDetails?.issueDate ?? null,
        localLagEntityName:
          ocrDetails?.nameInOtherLang || kycDetails?.localLagEntityName || "",
        preferredLanguage: kycLanguage,
        defaultLanguage: kycLanguage,
        address1: {
          location:
            ocrDetails?.address || kycDetails?.address1?.location || "Dubai",
          longitude: ocrDetails?.address
            ? 0
            : kycDetails?.address1?.longitude ?? 0,
          latitude: ocrDetails?.address
            ? 0
            : kycDetails?.address1?.latitude ?? 0,
        },
         address2:
           ocrDetails?.address || kycDetails?.address1?.location || null,
         baseCountry: accountDetails?.country ?? "",
         PrefCommunicationLaguage: kycLanguage,
         communicationPreference: CommonConstants.CommunicationPreference,
       };

        accountService
          .saveKYCInfo(payload)
          .then((response) => {
            if (response?.status === 200) {
              setSaveKycDetailLoader(false);
              Notification.success(
                t("KYC_DETAIL_KEY"),
                t("KYC_DETAILS_SUCCESS")
              );
              getSupplierKycInfo(user?.userId);
            } else {
              setSaveKycDetailLoader(false);
            }
          })
          .catch((error) => {
            setSaveProfileLoader(false);
            setSaveKycDetailLoader(false);
          });
      })
      .catch(() => {
        setSaveKycDetailLoader(false);
        Notification.error(t("ERROR_KEY"), t("FILL_MANDATORY_ERROR"));
      });
  };

  const getCityList = (value = "") => {
    setCityOptionsWaiter(true);
    masterDataService
      .getCityMasterBasedOnSearch(value)
      .then((response) => {
        setCityOptionsWaiter(false);
        if (response.status === 200) {
          setCityOptions(response.data);
        }
      })
      .catch((error) => {
        setCityOptionsWaiter(false);
        setCityOptions([]);
      });
  };

  const handleChangeTextClick = () => {
    // setIsChangeMobileVisible(true);
    if (accountDetails?.email) {
      emailChangeForm.setFieldValue("emailId", accountDetails?.email);
      setShowChangeText(false);
      setIsShowEmail(true);
    } else {
      setaddEmailModal(true);
    }
    emailInputRef.current?.focus();
  };

  const handleChangeTextClickMobile = () => {
    setIsChangeMobileVisible(true);
    MobileChangeForm.setFieldValue("countryCode", accountDetails?.countryCode);
    // setIsShowEmail(false);
    setShowChangeTextMobile(false);
    mobileInputRef.current?.focus();
  };

  const handleInputBlur = () => {
    setShowChangeText(true);
  };

  const handleInputBlurMobileNo = () => {
    setShowChangeTextMobile(true);
  };

  const handleCityChange = (value, option) => {
    form.setFieldsValue({ city: value });
    setAccountDetails((prevDetails) => ({
      ...prevDetails,
      city: value,
    }));
    setCityOptions([]);
  };

  const handleUserEmailChange = (e) => {
    form.setFieldsValue({ emailId: e.target.value });
    setAccountDetails((prevDetails) => ({
      ...prevDetails,
      email: e.target.value,
    }));
  };

  const handleCountryChange = (value, option) => {
    form.setFieldsValue({ country: value });
    setAccountDetails((prevDetails) => ({
      ...prevDetails,
      country: value,
    }));
    setCityOptions([]);
  };

  const handleMobileNoChange = (e) => {
    form.setFieldsValue({ mobileNo: e.target.value });
    setAccountDetails((prevDetails) => ({
      ...prevDetails,
      mobileNo: e.target.value,
    }));
  };

  // const handleNameChange = (e) => {
  //   form.setFieldsValue({ fullName: e.target.value });
  //   setAccountDetails((prevDetails) => ({
  //     ...prevDetails,
  //     fullName: e.target.value,
  //   }));
  // };

  const handleNameChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z\s.\-()]/g, "");
    value = value.replace(/ {2,}/g, " ");

    form.setFieldsValue({ fullName: value });
    setAccountDetails((prevDetails) => ({
      ...prevDetails,
      fullName: value,
    }));
  };

  const handleNameBlur = () => {
    const cleaned = accountDetails.fullName?.trim() || "";
    form.setFieldsValue({ fullName: cleaned });
    setAccountDetails((prevDetails) => ({
      ...prevDetails,
      fullName: cleaned,
    }));
  };

  const onFileUploadDocs = (file, fieldName) => {
    var updatedInquiryDocs = { ...frontDocs };
    updatedInquiryDocs = {
      docType: file.DocType,
      fileName: file.FileName,
      fileThumbName: file.FileThumbName,
      fileUrl: file.FileURL,
      isInsertUpdate: true,
      size: file.size,
      fileThumbUrl: file.FileThumbURL,
      fileData: file.fileData,
    };

    setFrontDocs(updatedInquiryDocs);
    //kycForm.setFieldsValue({ [fieldName]: file });
    kycForm.setFieldsValue({
      [fieldName]: {
        docType: file.DocType,
        fileName: file.FileName,
        fileThumbName: file.FileThumbName,
        fileUrl: file.FileURL,
        isInsertUpdate: true,
        isPathSet: true,
        size: file.size,
        fileThumbUrl: file.FileThumbURL,
      },
    });
  };

  const handleLocationChange = (selectedAddress) => {
    // Placepicker emits { address, lat, lng }, and everything downstream reads
    // address.location — the picker resets its own input if that goes undefined
    setAccountDetails((prevDetails) => ({
      ...prevDetails,
      address: {
        location: selectedAddress.address,
        latitude: selectedAddress.lat,
        longitude: selectedAddress.lng,
      },
    }));
    setAddressDetail({
      address: selectedAddress.address,
      latitude: selectedAddress.lat,
      longitude: selectedAddress.lng,
    });
    form.setFieldsValue({ address: selectedAddress.address });
  };

  const phoneCodeSetter = (val) => {
    const modifiedval = val.match(/[0,1,2,3,4,5,6,7,8,9]/g);
    form.setFieldValue(
      "countryCode",
      parseFloat(modifiedval.toString().replace(/,/g, "")).toString()
    );
    setAccountDetails((prevDetails) => ({
      ...prevDetails,
      countryCode: val,
    }));
  };

  const handleFormChange = (field, val) => {
    kycForm.setFieldValue(field, val);
    setKycFormValues((prev) => ({
      ...prev,
      [field]: val,
    }));
    kycForm.validateFields();
  };

  const addVisaRow = () => {
    const newVisa = {
      associateId: null,
      documentNumber: "",
      expiryDate: "",
      frontDoc: {
        documentPath: "",
        documentPathThumb: "",
        fileName: "",
      },
      backDoc: null,
      issuingCountry: null,
    };
    kycForm.setFieldsValue({
      [`visaNumber-${kycDetails.visa.length - 1}`]: newVisa.documentNumber,
      [`visaExpiry-${kycDetails.visa.length - 1}`]: dayjs(newVisa.expiryDate),
    });

    setKycDetails((prevDetails) => ({
      ...prevDetails,
      visa: [...prevDetails.visa, newVisa],
    }));
  };

  const addVisa = () => {
    setVisa([
      ...visa,
      {
        associateId: "",
        documentNumber: "",
        expiryDate: "",
        issuingCountry: "",
        frontDoc: {
          documentPath: "",
          documentPathThumb: "",
          fileName: "",
          isInsertUpdate: true,
          isPathSet: true,
        },
        document: [
          {
            documentPath: "",
            documentPathThumb: "",
            fileName: "",
          },
        ],
      },
    ]);
  };
  const handleVisaFormChange = (field, val) => {
    kycForm.setFieldValue(field, val);
    // setFormValues((prev) => ({
    //     ...prev,
    //     [field]: val,
    // }));
    kycForm.validateFields();
  };

  const handleFileUpload = (index, value) => {
    const updatedVisa = [...kycDetails.visa];
    updatedVisa[index].frontDoc = value;
    setKycDetails((prevDetails) => ({
      ...prevDetails,
      visa: updatedVisa,
    }));
  };

  const countNestedObjects = (inputObject) => {
    let count = 0;
    for (const key in inputObject) {
      if (typeof inputObject[key] === "object" && inputObject[key] !== null) {
        count++;
      }
    }
    return count;
  };

  const disablePastDates = (current) => {
    return current && current <= dayjs().endOf("day");
  };

  const handleVisa = (val, index) => {
    debugger;

    const tempList = [...visa];
    tempList[index] = {
      ...tempList[index],
      // frontDoc: {
      //   ...tempList[index].frontDoc,
      //   fileName: val.FileName || tempList[index].frontDoc.fileName,
      //   documentPath: val.FileURL || tempList[index].frontDoc.documentPath,
      //   documentPathThumb: val.FileThumbURL || tempList[index].frontDoc.documentPathThumb,
      //   isInsertUpdate: true,
      //   isPathSet: true
      // },
      // documentNumber: val.documentNumber || tempList[index].documentNumber,
      documentNumber:
        val.documentNumber !== undefined
          ? val.documentNumber
          : tempList[index].documentNumber,
      expiryDate: val?.expiryDate
        ? val?.expiryDate
        : tempList[index]?.expiryDate,
      // expiryDate: val?.expiryDate,
      issuingCountry: val.issuingCountry || tempList[index]?.issuingCountry,
    };
    debugger;
    setVisa(tempList);
    handleFormChange("visa", tempList)
  }
  
  // Ensure uniqueness among driverLicenseNumber, passportNumber, nationalIDNumber and all visa[*].documentNumber
 const uniqueDocNumberRule = (fieldName) => ({
  validator: (_, value) => {
    const val = value?.toString().trim();
    if (!val) return Promise.resolve();
     if (
      (removeUniquenessCheckForCountry(accountDetails?.country)) &&
      (fieldName === "driverLicenseNumber" || fieldName === "nationalIDNumber")
    ) {
      return Promise.resolve();
    }
    const {vatNumber,tradeLicenseNumber, driverLicenseNumber, passportNumber, nationalIDNumber, visa = [] } =
      kycForm.getFieldsValue();

    const allValues = [vatNumber,tradeLicenseNumber,driverLicenseNumber, passportNumber,nationalIDNumber,
      ...visa.map((v) => v?.documentNumber),
    ].filter(Boolean);
    const duplicates = allValues.filter((v) => v?.toString().trim() === val);
    return duplicates.length > 1
      ? Promise.reject(new Error(`Field must be unique`))
      : Promise.resolve();
  },
});


  const handleVisaDocumentChange = (val, index, documentIndex) => {
    let localVisa = [...visa];
    localVisa[index].frontDoc = {
      fileName: val.FileName,
      documentPath: val.FileURL,
      documentPathThumb: val.FileThumbURL,
      isInsertUpdate: true,
      isPathSet: true,
    };
    // localVisa[index].document[documentIndex] = {
    //   documentPath: val.FileURL,
    //   documentPathThumb: val.FileThumbURL,
    //   fileName: val.FileName,
    //   isInsertUpdate: true,
    // };
    setVisa(localVisa);
    handleFormChange("visa", localVisa);
  };
  const handleMobileModalCancel = () => {
    setIsChangeMobileVisible(false);
    setIsOldOTPVerified(true);
    MobileChangeForm.resetFields();
  };

  const handleEmailModalCancel = () => {
    setIsShowEmail(false);
    setIsOldOTPVerified(true);
    emailChangeForm.resetFields();
  };

  const MobileCountryCodeList = getMobileCountryCodeList(
    mobileCountryCodeList?.length > 0 ? mobileCountryCodeList : [],
    true
  );

  const handleCountryCodeFormChange = (field, val, option) => {
    MobileChangeForm.setFieldValue(field, val); // Update form value
    // MobileChangeForm.validateFields();
    if (field === "countryCode") {
      setconfirmMobileData((pre) => ({
        ...pre,
        [field]: val,
        countryCodeName: option?.country_code,
        countryName: option?.name,
      }));
      MobileChangeForm.setFieldValue("mobileNumber", "");
      getCountryWiseValidation(val);
    } else if (field === "mobileNumber") {
      if (val?.length < 13) {
        setconfirmMobileData((pre) => ({
          ...pre,
          [field]: val,
        }));
      }
    } else {
      setconfirmMobileData((pre) => ({
        ...pre,
        [field]: val,
      }));
    }
  };

  const handleFormInputChange = (field, val) => {
    // confirmMobileForm.setFieldValue(field, val);
    // confirmMobileForm.validateFields();

    setconfirmMobileData((pre) => ({
      ...pre,
      [field]: val,
    }));
  };

  const onRequestOTP = async () => {
    setemailOtpLoader(false);
    MobileChangeForm.validateFields() // Validate fields
      .then(() => {
        const countryCode = MobileChangeForm?.getFieldValue("countryCode");
        const mobileNumber = MobileChangeForm?.getFieldValue("mobileNumber");
        const email = MobileChangeForm?.getFieldValue("emailId");

        // setemailOtpLoader(false)

        otpService
          .userExistsApi(countryCode, mobileNumber, "", "", false)
          .then(async (res) => {
            setemailOtpLoader(true);
            if (res?.status === 200) {
              const isUserExists = res?.data?.data?.isUserExists;
              setUserExists(isUserExists);
              if (isUserExists) {
                Notification.error(t("NUMBER_EXIST_ERROR"));
              } else {

                let token = "";
                try {
                  token = await executeRecaptcha("otp_request_action");
                  console.log("RECAPTCHA TOKEN:", token);
                } catch (recaptchaError) {
                  console.error("reCAPTCHA failed:", recaptchaError);
                  Notification.error("reCAPTCHA verification failed. Please try again.");
                    updateIsOTPRequested(false);
                    setemailOtpLoader(false);
                  return;
                }
                  console.log("RECAPTCHA TOKEN: ", token);


                const payload = {
                  countryCode,
                  mobileNo: mobileNumber,
                  otpType: "OtpSend",
                  languageISOCode: language,
                  captchaToken: token, 
                };
                otpService?.sendOTP(payload).then((response) => {
                  setemailOtpLoader(false);

                  if (response?.status === 200) {
                    setOtpDetails(response?.data);
                    localStorageService.setKey(
                      LocalStorageKeys.UniqueId,
                      response?.data?.data
                    );
                    Notification.success(t("OTP_SENT_SUCCESS"));
                    setIsOTPVerified(false);
                    setNewOTPRequested(true);
                    updateIsOTPRequested(true);
                    // setRequestLoader(true);
                    setemailOtpLoader(false);
                    setTimer(120);
                  } else {
                    updateIsOTPRequested(false);
                    setemailOtpLoader(false);
                  }
                });
              }
            }
          })
          .catch((err) => {
            // Notification.error('User already exists. Please login!');
          });
      })
      .catch(() => {
        Notification.error(t("CORRECTION_FORM_ERROR"));
      });
  };

  const sendOldNumberOtp = async () => {
      let token = "";
      try {
        token = await executeRecaptcha("otp_request_action");
        console.log("RECAPTCHA TOKEN:", token);
      } catch (recaptchaError) {
        console.error("reCAPTCHA failed:", recaptchaError);
        Notification.error("reCAPTCHA verification failed. Please try again.");
        updateIsOTPRequested(false);
        setRequestLoader(false);
        return;
      }
        console.log("RECAPTCHA TOKEN: ", token);

    const payload = {
      countryCode: accountDetails?.countryCode,
      mobileNo: accountDetails?.mobileNo,
      otpType: "OtpSend",
      languageISOCode: language,
      captchaToken: token, 
      // emailId: accountDetails?.emailId ? accountDetails?.emailId:"",
    };
    // const payload = {
    //   countryCode:!showEmail?accountDetails?.countryCode:0,
    //   // mobileNo: !showEmail ?accountDetails?.mobileNo:"",
    //   mobileNo:accountDetails?.mobileNo,
    //   otpType: 'OtpSend',
    //   languageISOCode: language,
    //   emailId: showEmail ? accountDetails?.email : ""
    // };

    otpService
      ?.sendOTP(payload)
      .then((response) => {
        if (response?.status === 200) {
          setOtpDetails(response?.data);
          localStorageService.setKey(
            LocalStorageKeys.UniqueId,
            response?.data?.data
          );
          Notification.success(t("OTP_SENT_SUCCESS"));
          updateIsOTPRequested(true);
          // setRequestLoader(true);
          setemailOtpLoader(false);
        } else {
          updateIsOTPRequested(false);
        }
      })
      .catch((error) => {
        Notification.error(t("SEND_OTP_FAILED_ERROR"));
        updateIsOTPRequested(false);
        setRequestLoader(false);
      });
  };

  const verifyOTPDetails = async () => {
    setemailOtpLoader(true);

    MobileChangeForm.validateFields();
    const uniqueId = localStorageService.getValue(LocalStorageKeys.UniqueId);
    try {
      // await confirmMobileForm.validateFields(["otpNumber"]);
      // const otp = confirmMobileForm.getFieldValue("otpNumber");
      const countryCode = MobileChangeForm?.getFieldValue("countryCode");
      const payload = {
        uniqueId: uniqueId ? uniqueId : "",
        otpNumber: oldOtp,
        countryCode: countryCode,
        otpType: "OtpSend",
        languageISOCode: language,
      };
      const response = await otpService.verifyOTP(payload);
      if (response) {
        Notification.success(t("SUCCESS_KEY"), t("OTP_VERIFIED_SUCCESS"));
        setemailOtpLoader(false);
        // onSectionChange(val);
        setIsOldOTPVerified(false);
        setIsOTPVerified(true);
        updateIsOTPRequested(false);
      }
    } catch (error) {
      setemailOtpLoader(false);
    }
  };

  const removeVisa = (index) => {
    const updatedVisa = visa.filter((_, i) => i !== index);
    setVisa(updatedVisa);
  };

  const onResendOTP = async () => {
    const countryCode = form?.getFieldValue("countryCode");
    const uniqueId = localStorageService.getValue(LocalStorageKeys.UniqueId);
    if (timer === 0) {
      setRequestLoader(true);
      //  Recaptcha Token for resend
      let token = "";
      try {
        token = await executeRecaptcha("otp_request_action"); 
        console.log("RECAPTCHA TOKEN:", token);
      } catch (recaptchaError) {
        console.error("reCAPTCHA failed:", recaptchaError);
        Notification.error("reCAPTCHA verification failed. Please try again.");
        setRequestLoader(false);
        return;
      }

      const otpType = "OtpSend";
      const payload = {
        uniqueId: uniqueId,
        countryCode: countryCode,
        otpType: otpType,
        languageISOCode: language,
        captchaToken: token
      };
      try {
        const response = await otpService.resendOTP(payload);
        if (response?.status === 200) {
          setTimer(120);
          setOtpDetails(response?.data);
          localStorageService.setKey(LocalStorageKeys.UniqueId, uniqueId);
          updateIsOTPRequested(true);
          setRequestLoader(false);
          Notification.success(t("SUCCESS_KEY"), t("OTP_SENT_SUCCESS"));
        }
      } catch (error) {
        setRequestLoader(false);
        console.error("Error while resending OTP:", error);
      }
    }
  };

  // verify email apis

  const onRequestOtpEmali = async () => {
    let token = "";
    try {
      token = await executeRecaptcha("otp_request_action");
      console.log("RECAPTCHA TOKEN:", token);
    } catch (recaptchaError) {
      console.error("reCAPTCHA failed:", recaptchaError);
      Notification.error("reCAPTCHA verification failed. Please try again.");
        updateIsOTPRequested(false);
        setOtpLoader(false);
      return;
    }
      console.log("RECAPTCHA TOKEN: ", token);


    // setRequestLoader(true);
    const emailId = emailChangeForm?.getFieldValue("emailId");
    const payload = {
      countryCode: 0,
      // mobileNo: accountDetails?.mobileNo,
      otpType: "OtpSend",
      languageISOCode: language,
      // emailId: accountDetails?.email
      emailAddress: accountDetails?.email ? accountDetails?.email : emailId, // Use emailId from the form only if accountDetails.email exists

      // emailId: accountDetails?.emailId ? accountDetails?.emailId:"",
      captchaToken: token, 
    };

    otpService
      ?.sendOTP(payload)
      .then((response) => {
        if (response?.status === 200) {
          setOtpDetails(response?.data);
          localStorageService.setKey(
            LocalStorageKeys.UniqueId,
            response?.data?.data
          );
          Notification.success(t("OTP_SENT_SUCCESS"));
          updateIsOTPRequested(true);
          // setRequestLoader(true);
          setOtpLoader(false);
        } else {
          updateIsOTPRequested(false);
        }
      })
      .catch((error) => {
        Notification.error(t("SEND_OTP_FAILED_ERROR"));
        updateIsOTPRequested(false);
        setOtpLoader(false);

        // setRequestLoader(false);
      });
  };

  const verifyEmailOTPDetails = async (val) => {
    setOtpLoader(true);

    const uniqueId = localStorageService.getValue(LocalStorageKeys.UniqueId);
    // setIsConfirmPin(true);
    //  setOtpVerifyLoader(true);
    try {
      const payload = {
        uniqueId: uniqueId ? uniqueId : "",
        otpNumber: oldOtp,
        emailId: accountDetails?.email.includes("@")
          ? accountDetails?.email
          : "",
        userId: "",
      };
      const response = await otpService.verifyForgetOTP(payload);
      if (response) {
        setOtpLoader(false);
        Notification.success(t("SUCCESS_KEY"), t("OTP_VERIFIED_SUCCESS"));
        localStorageService.setKey(LocalStorageKeys.UniqueId, otpDetails?.data);
        //  setOtpVerifyLoader(false);
        setIsOldOTPVerified(false);
        //  setIsConfirmPin(true);
        setIsOTPVerified(true);
        updateIsOTPRequested(false);
      }
    } catch (error) {
      setOtpLoader(false);
    }
  };

  const onRequestEmailOTP = () => {
    setOtpLoader(true);
    setAddEmailOtpLoader(true);

    emailChangeForm
      .validateFields()
      .then(() => {
        const countryCode = "";
        const mobileNumber = "";
        const emailId = emailChangeForm?.getFieldValue("emailId");

        otpService
          .userExistsApi(countryCode, mobileNumber, emailId, "", false)
          .then(async (res) => {
            if (res?.status === 200) {
              const isUserExists = res?.data?.data?.isUserExists;
              setUserExists(isUserExists);
              if (isUserExists) {
                Notification.error(t("EMAIL_EXIST_ERROR"));
                setOtpLoader(false);
              } else {
              let token = "";
              try {
                token = await executeRecaptcha("otp_request_action");
                console.log("RECAPTCHA TOKEN:", token);
              } catch (recaptchaError) {
                console.error("reCAPTCHA failed:", recaptchaError);
                Notification.error("reCAPTCHA verification failed. Please try again.");
                updateIsOTPRequested(false);
                return;
              }
               console.log("RECAPTCHA TOKEN: ", token);

                const payload = {
                  countryCode: 0,
                  otpType: "OtpSend",
                  languageISOCode: language,
                  // emailId: accountDetails?.email ? accountDetails.email : '',  // Use email if it exists, otherwise empty
                  emailAddress: emailId, // Use emailId from the form only if accountDetails.email exists
                  captchaToken: token, 
                };
                otpService?.sendOTP(payload).then((response) => {
                  if (response?.status === 200) {
                    setOtpDetails(response?.data);
                    localStorageService.setKey(
                      LocalStorageKeys.UniqueId,
                      response?.data?.data
                    );
                    Notification.success(t("OTP_SENT_SUCCESS"));
                    setIsOTPVerified(false);
                    setNewOTPRequested(true);
                    updateIsOTPRequested(true);
                    setisAddEmailOtpVerified(true);
                    // setRequestLoader(true);
                    setOtpLoader(false);
                    setAddEmailOtpLoader(false);

                    setTimer(120);
                  } else {
                    updateIsOTPRequested(false);
                  }
                });
              }
            }
          })
          .catch((err) => {
            // Notification.error('User already exists. Please login!');
          });
      })
      .catch(() => {
        Notification.error(t("CORRECTION_FORM_ERROR"));
      });
  };

  const newMobileChangeSuccess = async () => {
    setemailOtpLoader(true);

    const uniqueId = localStorageService.getValue(LocalStorageKeys.UniqueId);
    const mobileNo = MobileChangeForm.getFieldValue("mobileNumber");
    const newOtpNumber = MobileChangeForm.getFieldValue("newOtpNumber");
    const countryCode = MobileChangeForm.getFieldValue("countryCode");

    try {
      const payload = {
        countryCode: countryCode,
        mobileNo: mobileNo,
        uniqueId: uniqueId ? uniqueId : "",
        otpNumber: newOtpNumber,
      };
      const response = await otpService.verifyOtpToChangeMobileNumber(payload);
      if (response) {
        setemailOtpLoader(false);
        localStorageService.setKey(LocalStorageKeys.UniqueId, otpDetails?.data);

        const refreshPayload = {
          accessToken,
          refreshToken,
        };
        otpService.refreshToken(refreshPayload).then((response) => {
          if (response?.data?.data) {
            localStorageService.setKey(
              LocalStorageKeys.AuthToken,
              response.data.data.accessToken
            );
            localStorageService.setKey(
              LocalStorageKeys.RefreshToken,
              response.data.data.refreshToken
            );
            // return response.data.data.accessToken;
            setemailOtpLoader(false);
            setIsChangeMobileVisible(false);
            Notification.success(
              t("SUCCESS_KEY"),
              t("MOBILE_NO_CHANGE_SUCCESS")
            );
            MobileChangeForm.resetFields();
          }

          getAccountDetails(user?.userId);
        });
      }

      setNewOTPRequested(false);
    } catch (error) {
      setemailOtpLoader(false);
      console.error("Failed to refresh token:", error);
      // window.localStorage.clear();
      // navigate("/login");
    }
  };

  const newEmailIDChangeSuccess = async () => {
    setOtpLoader(true);
    setAddEmailOtpLoader(true);
    setaddEmailModal(false);
    const uniqueId = localStorageService.getValue(LocalStorageKeys.UniqueId);
    const email = emailChangeForm.getFieldValue("emailId");
    const newOtpNumber = emailChangeForm.getFieldValue("newOtpNumber");

    try {
      const payload = {
        email: email,
        uniqueId: uniqueId ? uniqueId : "",
        otpNumber: newOtpNumber,
      };
      const response = await otpService.verifyOtpToChangeEmail(payload);
      if (response) {
        setOtpLoader(false);
        setAddEmailOtpLoader(false);
        localStorageService.setKey(LocalStorageKeys.UniqueId, otpDetails?.data);

        const refreshPayload = {
          accessToken,
          refreshToken,
        };
        otpService.refreshToken(refreshPayload).then((response) => {
          if (response?.data?.data) {
            localStorageService.setKey(
              LocalStorageKeys.AuthToken,
              response.data.data.accessToken
            );
            localStorageService.setKey(
              LocalStorageKeys.RefreshToken,
              response.data.data.refreshToken
            );
            // return response.data.data.accessToken;
            setOtpLoader(false);
            setAddEmailOtpLoader(false);
            setIsShowEmail(false);
            Notification.success(
              t("SUCCESS_KEY"),
              t("EMAIL_ID_CHANGE_SUCCESS")
            );
            emailChangeForm.resetFields();
          }
          getAccountDetails(user?.userId);
        });
      }

      setNewOTPRequested(false);
    } catch (error) {
      setOtpLoader(false);
      setAddEmailOtpLoader(false);
      console.error("Failed to refresh token:", error);
    }
  };

  //function to add new field for IBAN number
  const addIbanNumber = () => {
    let temp = [...ibanNumber];
    temp.push("");
    setIbanNumber(temp);
  };

  const onProfilePictureUpload = (file, fieldName) => {
    uploadImageForm.setFieldsValue({
      [fieldName]: {
        docType: DocTypes.PROFILE_PIC,
        fileName: file.FileName,
        fileThumbName: file.FileThumbName,
        fileUrl: file.FileURL,
        size: file.size,
        fileThumbUrl: file.FileThumbURL,
      },
    });
  };

  const handleUploadProfile = () => {
    setImageUploadLoader(true);
    const uploadedFile = uploadImageForm.getFieldValue("uploadImage");
    if (!uploadedFile || !uploadedFile.fileUrl) {
      uploadImageForm.setFields([
        {
          name: "uploadImage",
          errors: [t("UPLOAD_PROFILE_PIC_MSG")],
        },
      ]);

      setImageUploadLoader(false);
      return;
    }
    setTimeout(() => {
      saveProfileDetails();

      setImageUploadLoader(false);
      setIsUploadImage(false);
    }, 2000);
  };

  const refreshBasicInfo = () => {
    getAccountDetails();
  };

  // const EllipsisText = ({ text }) => {
  //   return (
  //     <Col className="ellipsis-container" span={24}>
  //       <p className="ellipsis-text">{text}</p>
  //       <div className="ellipsis-tooltip">{text}</div>
  //     </Col>
  //   );
  // };
  const submitHanlerFunction = () => {
    getSupplierKycInfo();
  };

  // ****************** OCR EDIT  *****************
  const OCRFieldNames = {
    VAT_CERTIFICATE: "VAT_CERTIFICATE",
    TRADE_LICENSE: "TRADE_LICENSE",
    DRIVING_LICENSE: "DRIVING_LICENSE",
    PASSPORT: "PASSPORT",
    NATIONAL_ID: "NATIONAL_ID",
    VISA: "VISA",
  };

  const ocrFieldToStateKey = {
    [OCRFieldNames.VAT_CERTIFICATE]: "vatCertificate",
    [OCRFieldNames.TRADE_LICENSE]: "tradeLicense",
    [OCRFieldNames.DRIVING_LICENSE]: "drivingLicense",
    [OCRFieldNames.PASSPORT]: "passport",
    [OCRFieldNames.NATIONAL_ID]: "nationalID",
    [OCRFieldNames.VISA]: "visa",
  };

  const config = {
    onUploadProgress: function (progressEvent) {
      console.log("progressEvent.total", progressEvent.total);
      console.log("progressEvent.loaded", progressEvent.loaded);
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      console.log("percentCompleted", percentCompleted);

      setUploadState((prev) => {
        let status = "";
        let description = "";

        if (!prev.started) {
          status = t("OCR_MODAL_HOLD_TIGHT_MSG");;
          description = t("OCR_MODAL_DO_NOT_CLOSE_MSG");
          if (percentCompleted === 100) {
            status = t("OCR_MODAL_FINAL_STEP")
            description = t("OCR_MODAL_HANG_ON_MSG");
          }
        } else if (percentCompleted < 30) {
          status = t("OCR_MODAL_HOLD_TIGHT_MSG");
          description = t("OCR_MODAL_DO_NOT_CLOSE_MSG");
        } else if (percentCompleted < 70) {
          status = t("OCR_MODAL_ALMOST_THERE_MSG");
          description = t("OCR_MODAL_RIGHT_PLACE_MSG");
        } else if (percentCompleted < 100) {
          status = t("OCR_MODAL_FINAL_STEP")
          description = t("OCR_MODAL_HANG_ON_MSG");
        } else {
          status = t("OCR_MODAL_FINAL_STEP")
          description = t("OCR_MODAL_HANG_ON_MSG");
        }

        return {
          progress: percentCompleted,
          status,
          description,
          started: true,
        };
      });
    },
  };

  //******* */ upload directly to CLOUD *********
  const uploadDirectToCloud = async (
    fileWrapper,
    fieldName,
    ocrFieldName,
    fileType,
    index
  ) => {
    const actualFile = fileWrapper.file ?? fileWrapper;

    const form = new FormData();
    form.append("file", actualFile);

    const payload = {
      docType: fileType,
      entityType: EntityTypes.SUPPLIER,
      fileName: actualFile.name,
      docName: actualFile.name ? actualFile.name.replace(/\s+/g, "_") : "",
      fileData: "",
      fileURL: "",
      fileThumbURL: "",
      fileThumbName: "",
      uniqueID: "",
      totalPartition: 1,
      seq: 1,
      isPathSet: true,
    };

    form.append("details", JSON.stringify(payload));

    try {
      const response = await uploadDocumentV2(form, config);
      if (response.data.status === 200) {
        const data = response.data.data;
        console.log("uploadDocumentV2 data", data);

        const stateKey = ocrFieldToStateKey[ocrFieldName];
        console.log("stateKey", stateKey);

        // VISA HANDLED HERE
        if (ocrFieldName === OCRFieldNames.VISA && index !== null) {
          let localVisa = [...visa];
          localVisa[index].frontDoc = {
            ...localVisa[index].frontDoc,
            fileName: data.fileName || "",
            documentPath: data.fileURL || "",
            documentPathThumb: data.fileThumbURL || "",
            isInsertUpdate: true,
            isOCRDoc: false,
          };

          setVisa(localVisa);
          handleFormChange("visa", localVisa);
        } else {
          const isBackDoc =
            fieldName?.toLowerCase().includes("back") &&
            (ocrFieldName === OCRFieldNames.DRIVING_LICENSE ||
              ocrFieldName === OCRFieldNames.NATIONAL_ID ||
              ocrFieldName === OCRFieldNames.PASSPORT);

          setEditAccountDocs((prev) => ({
            ...prev,
            [stateKey]: {
              ...prev?.[stateKey],
              ...(isBackDoc
                ? {
                    backDoc: {
                      ...prev?.[stateKey]?.backDoc,
                      documentPath: data.fileURL || null,
                      documentPathThumb: data.fileThumbURL || null,
                      fileName: data.fileName || null,
                    },
                  }
                : {
                    frontDoc: {
                      ...prev?.[stateKey]?.frontDoc,
                      documentPath: data.fileURL || null,
                      documentPathThumb: data.fileThumbURL || null,
                      fileName: data.fileName || null,
                    },
                  }),
            },
          }));

          const normalizedFile = {
            DocType: data.docType,
            EntityId: data.entityId,
            FileName: data.fileName,
            FileThumbName: data.fileThumbName,
            FileThumbURL: data.fileThumbURL,
            FileURL: data.fileURL,
            Status: data.status ?? false,
          };

          console.log("normalizedFile", normalizedFile);

          onFileUploadDocs(normalizedFile, fieldName);
        }

        Notification.success(t("SUCCESS_KEY"), t("FILE_UPLOADED_SUCCESS"));
      } else {
        Notification.error(response.data.message || "Upload failed");
      }
    } catch (error) {
      console.error("uploadDirectToJCloud error", error);
      Notification.error(t("ERROR_MESSAGE"));
    }
  };

  const ocrMappedData = (ocrFieldName, doc, index) => {
    console.log("ocrMappedData doc", doc);
    console.log("ocrMappedData index", index);

    // Not shown in the form, only carried through to the save payloads.
    // STO reads them off the personal documents, everyone else off the VAT one.
    if (ocrSourceDocTypes.includes(ocrFieldName)) {
      captureOcrDetails(doc);
    }

    switch (ocrFieldName) {
      case "VAT_CERTIFICATE": {
        const { docNumber, docExpiryDate, frontUrl } = doc;
        const parsedVatExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const vatUpload = {
          // DocType: doc.docType || "VATCERTFD",
          // EntityId: EntityTypes.SUPPLIER,
          // FileName: `ActualSupplier/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(frontUrl)}`,
          // FileThumbName: `ActualSupplier_Thumb/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(frontUrl)}`,
          // FileThumbURL: documentUtility.getThumbnailImagePath(frontUrl) || null,
          // FileURL: frontUrl || null,
          // Status: false,
          docType: doc.docType || "VATCERTFD",
          fileName: `ActualSupplier/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
            frontUrl
          )}`,
          fileThumbName: `ActualSupplier_Thumb/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
            frontUrl
          )}`,
          fileUrl: frontUrl || null,
          fileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          isPathSet: true,
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setEditAccountDocs((prev) => ({
          ...prev,
          vatCertificate: {
            ...prev?.vatCertificate,
            frontDoc: {
              ...prev?.frontDoc,
              documentPath: vatUpload.fileUrl || null,
              documentPathThumb: vatUpload.fileThumbUrl || null,
              fileName: vatUpload.fileName || null,
            },
          },
        }));

        setKycFormValues((prev) => ({
          ...prev,
          vatNumber: docNumber || undefined,
          vatExpiry: parsedVatExpiry,
          vatUpload,
        }));

        kycForm.setFieldsValue({
          vatNumber: docNumber || undefined,
          vatExpiry: parsedVatExpiry,
          vatUpload,
        });
        break;
      }

      case "TRADE_LICENSE": {
        const { docNumber, docExpiryDate, frontUrl } = doc;
        const parsedTradeExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const licenceUpload = {
          // DocType: doc.docType || "TRADELICFD",
          // EntityId: EntityTypes.SUPPLIER,
          // FileName: `ActualSupplier/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(frontUrl)}`,
          // FileThumbName: `ActualSupplier_Thumb/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(frontUrl)}`,
          // FileThumbURL: documentUtility.getThumbnailImagePath(frontUrl) || null,
          // FileURL: frontUrl || null,
          // Status: false,
          docType: doc.docType || "TRADELICFD",
          fileName: `ActualSupplier/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(
            frontUrl
          )}`,
          fileThumbName: `ActualSupplier_Thumb/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(
            frontUrl
          )}`,
          fileUrl: frontUrl || null,
          fileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setEditAccountDocs((prev) => ({
          ...prev,
          tradeLicense: {
            ...prev?.tradeLicense,
            frontDoc: {
              ...prev?.frontDoc,
              documentPath: licenceUpload?.fileUrl || null,
              documentPathThumb: licenceUpload?.fileThumbUrl || null,
              fileName: licenceUpload?.fileName || null,
            },
          },
        }));

        kycForm.setFieldsValue({
          tradeLicenseNumber: docNumber || undefined,
          tradeExpiry: parsedTradeExpiry,
          tradeLicenseUpload: licenceUpload,
        });

        setKycFormValues((prev) => ({
          ...prev,
          tradeLicenseNumber: docNumber || undefined,
          tradeExpiry: parsedTradeExpiry,
          tradeLicenseUpload: licenceUpload,
        }));

        break;
      }

      case "DRIVING_LICENSE": {
        const { docNumber, docExpiryDate, frontUrl, backUrl } = doc;
        const parsedTradeExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const frontDoc = {
          docType: "DRLFD",
          fileName:
            `ActualDriver/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          fileUrl: frontUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const backDoc = {
          docType: "DRLBD",
          fileName:
            `ActualDriver/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbUrl: backUrl || null,
          fileUrl: backUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setEditAccountDocs((prev) => ({
          ...prev,
          drivingLicense: {
            ...prev?.drivingLicense,
            frontDoc: {
              ...prev?.frontDoc,
              documentPath: frontDoc?.fileUrl || null,
              documentPathThumb: frontDoc?.fileThumbUrl || null,
              fileName: frontDoc?.fileName || null,
            },
            backDoc: {
              ...prev?.backDoc,
              documentPath: backDoc?.fileUrl || null,
              documentPathThumb: backDoc?.fileThumbUrl || null,
              fileName: backDoc?.fileName || null,
            },
          },
        }));

        kycForm.setFieldsValue({
          driverLicenseNumber: docNumber || undefined,
          driverExpiry: parsedTradeExpiry,
          licenceFront: frontDoc,
          licenceBack: backDoc,
        });

        setKycFormValues((prev) => ({
          ...prev,
          driverLicenseNumber: docNumber || undefined,
          driverExpiry: parsedTradeExpiry,
          licenceFront: frontDoc,
          licenceBack: backDoc,
        }));

        break;
      }

      case "NATIONAL_ID": {
        const { docNumber, docExpiryDate, frontUrl, backUrl } = doc;
        const parsedTradeExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const frontDoc = {
          docType: "NIDFD",
          fileName:
            `ActualDriver/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          fileUrl: frontUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const backDoc = {
          docType: "NIDBD",
          fileName:
            `ActualDriver/${ocrLogId}_NIDBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_NIDBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbUrl: backUrl || null,
          fileUrl: backUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setEditAccountDocs((prev) => ({
          ...prev,
          nationalID: {
            ...prev?.nationalID,
            frontDoc: {
              ...prev?.frontDoc,
              documentPath: frontDoc?.fileUrl || null,
              documentPathThumb: frontDoc?.fileThumbUrl || null,
              fileName: frontDoc?.fileName || null,
            },
            backDoc: {
              ...prev?.backDoc,
              documentPath: backDoc?.fileUrl || null,
              documentPathThumb: backDoc?.fileThumbUrl || null,
              fileName: backDoc?.fileName || null,
            },
          },
        }));

        kycForm.setFieldsValue({
          nationalIDNumber: docNumber || undefined,
          nationalIDExpiry: parsedTradeExpiry,
          nationalIdFront: frontDoc,
          nationalIdBack: backDoc,
        });

        setKycFormValues((prev) => ({
          ...prev,
          nationalIDNumber: docNumber || undefined,
          nationalIDExpiry: parsedTradeExpiry,
          nationalIdFront: frontDoc,
          nationalIdBack: backDoc,
        }));

        break;
      }

      case "PASSPORT": {
        const { docNumber, docExpiryDate, frontUrl, backUrl } = doc;
        const parsedTradeExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const frontDoc = {
          docType: "PASSFD",
          fileName:
            `ActualDriver/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          fileUrl: frontUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const backDoc = {
          docType: "PASSBD",
          fileName:
            `ActualDriver/${ocrLogId}_PASSBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_PASSBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbUrl: backUrl || null,
          fileUrl: backUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setEditAccountDocs((prev) => ({
          ...prev,
          passport: {
            ...prev?.drivingLicense,
            frontDoc: {
              ...prev?.frontDoc,
              documentPath: frontDoc?.fileUrl || null,
              documentPathThumb: frontDoc?.fileThumbUrl || null,
              fileName: frontDoc?.fileName || null,
            },
            backDoc: {
              ...prev?.backDoc,
              documentPath: backDoc?.fileUrl || null,
              documentPathThumb: backDoc?.fileThumbUrl || null,
              fileName: backDoc?.fileName || null,
            },
          },
        }));

        kycForm.setFieldsValue({
          passportNumber: docNumber || undefined,
          passportExpiry: parsedTradeExpiry,
          passportFront: frontDoc,
          passportBack: backDoc,
        });
        break;
      }

      case "VISA": {
        const { docNumber, docExpiryDate, frontUrl, issueCountry } = doc;
        const parsedVisaExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").isValid()
            ? dayjs(docExpiryDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : docExpiryDate
          : "";

        const visaFront = {
          fileName:
            `ActualDriver/${ocrLogId}_VISA${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          documentPath: frontUrl || null,
          documentPathThumb:
            documentUtility.getThumbnailImagePath(frontUrl) || null,
          isInsertUpdate: false,
          isOCRDoc: true,
          isPathSet: true,
        };

        console.log("visaFront", visaFront);

        if (index !== null && index !== undefined) {
          let localVisa = [...visa];
          localVisa[index] = {
            ...localVisa[index],
            documentNumber: docNumber || "",
            issuingCountry: issueCountry || "",
            expiryDate: parsedVisaExpiry,
            frontDoc: {
              ...localVisa[index].frontDoc,
              ...visaFront,
            },
          };

          setVisa(localVisa);
          handleFormChange("visa", localVisa);
        }

        break;
      }

      default: {
        console.warn(
          `No mapping found in ocrMappedData for docType: ${ocrFieldName}`,
          doc
        );

        break;
      }
    }
  };

  const uploadToOCR = async (ocrConfirmedFiles) => {
    if (!ocrConfirmedFiles || ocrConfirmedFiles.length === 0) return;

    const parserAppMap = {
      // truck: process.env.REACT_APP_OCR_ASSET,
      // fleet: process.env.REACT_APP_OCR_SHIPPER_SUPPLIER,
      // driver: process.env.REACT_APP_OCR_DRIVER_STO,
      truck: "RDLj2vIouDleRWu0",
      fleet: "mCFBiv6Hcl8U02Sp",
      // driver: "2p1fqkPj0wFL9T0E",
      driver: "testqkPj0wFL9T0E",
    };
    // const parserApp = parserAppMap["fleet"] || "";
    const parserKey = ownerType === "STO" ? "driver" : "fleet";
    const parserApp = parserAppMap[parserKey] || "";
    console.log("parserApp", parserApp);
    const form = new FormData();
    // form.append("file", uploadedFileData.file);

    ocrConfirmedFiles.forEach((item) => {
      if (item?.file) {
        form.append("files", item.file);
      }
    });
    form.append("parserApp", parserApp);
    form.append("userType", user?.userRole || "");
    form.append("countryCode", String(user?.countryCode || ""));
    form.append("entityType",EntityTypes.SUPPLIER);
    // form.append("model", "v1");
    // form.append("extra_accuracy", "false");
    try {
      console.log("Sending to OCR", form.getAll("files"), parserApp);
      const response = await ocrCustomFileUploadService(form, config);
      const parsedData = response?.data?.data?.parsedData;
      // const ocrLogId = response?.data?.data?.ocrLogId;
      const newOcrLogId  = response?.data?.data?.ocrLogId;
      if (parsedData && newOcrLogId) {
        console.log("uploadToOCR parsedData", parsedData);
        setOcrParsedData(parsedData);
        // setOcrLogId(ocrLogId);
        setOcrLogId(prev =>
          prev ? `${prev},${newOcrLogId}` : String(newOcrLogId)
        );
        return parsedData;
      } else {
        console.warn("No parsedData in OCR response");
        // setOcrLogId("");
      }
    } catch (error) {
      console.error("OCR Upload Failed:", error);
      const message =
        error?.response?.data?.message ||
        "OCR upload failed due to a server error.";
      Notification.error("Upload Failed", message);
    }
  };

  const handleOCRConformFileChange = async (
    newFiles,
    fieldName,
    ocrFieldName,
    fileType,
    index = null
  ) => {
    if (!newFiles || newFiles.length === 0) return;

    console.log("handleOCRConformFileChange newFiles", newFiles[0]);
    console.log("handleOCRConformFileChange fieldName", fieldName);

    setUploadState(initialUploadState);
    setIsUploadingPopupVisible(true);

    let responseParseData = null;
    try {
      // Calling the OCR API function to fetch OCR data
      responseParseData = await uploadToOCR(newFiles);
    } catch (error) {
      console.error("OCR failed, will fallback to direct upload", error);
    }

    // IF Data is From OCR and Data is Correct as per ocrFieldName
    if (responseParseData?.documents?.length) {
      const documents = responseParseData.documents;
      const matchedDoc = documents.find(
        (doc) => doc.docType === ocrFieldName && doc.status === true
      );

      if (matchedDoc) {
        ocrMappedData(ocrFieldName, matchedDoc, index);
        debugger;
        setIsUploadingPopupVisible(false);
        return;
      }
    }

    //  OCR failed or didn’t match → direct upload to Cloud
    try {
      debugger;
      await uploadDirectToCloud(
        newFiles[0],
        fieldName,
        ocrFieldName,
        fileType,
        index
      );
    } catch (err) {
      console.error("Direct upload failed too:", err);
    } finally {
      setIsUploadingPopupVisible(false); // close popup after cloud upload
    }
  };

  const handleEditClick = () => {
    setEditAccountDocs(structuredClone(kycDetails)); // deep clone
    // setIsEditModalOpen(true);
  };

  const handleEditingDeleteFile = (fieldName, ocrFieldName) => {
    console.log("handleEditingDeleteFile", fieldName);
    const stateKey = ocrFieldToStateKey[ocrFieldName];

    setEditAccountDocs((prev) => {
      const updated = { ...prev };

      if (
        ["licenceBack", "nationalIdBack", "passportBack"].includes(fieldName)
      ) {
        // Delete from backDoc
        updated[stateKey] = {
          ...prev?.[stateKey],
          backDoc: {
            documentPath: null,
            documentPathThumb: null,
            fileName: null,
          },
        };
      } else {
        // Delete from frontDoc
        updated[stateKey] = {
          ...prev?.[stateKey],
          frontDoc: {
            documentPath: null,
            documentPathThumb: null,
            fileName: null,
          },
        };
      }

      return updated;
    });
  };

  const handleVisaDeleteFileUpload = (index) => {
    setVisa((prev) => {
      const updatedVisa = [...prev];

      updatedVisa[index].frontDoc = {
        ...updatedVisa[index].frontDoc,
        fileName: "",
        documentPath: "",
        documentPathThumb: "",
        isInsertUpdate: false,
        isOCRDoc: false,
        isPathSet: false,
      };

      return updatedVisa;
    });
  };

  return (
    <>
      {isGuest ? (
        <div>{GuestWarningContainer(t)}</div>
      ) : (
        <div className="account-wrapper">
          {!profileEditStatus ? (
            <>
              <div>
                <Card
                  style={{
                    height: checkIsInternalSourcing(user?.userRole)
                      ? "300px"
                      : "200px",
                    borderRadius: "16px",
                  }}
                >
                  <Row>
                    <Col span={4}>
                      {userDetailLoader ? (
                        <Spin
                          style={{ marginLeft: "25%", marginTop: "20%" }}
                        ></Spin>
                      ) : (
                        <img
                          src={
                            userProfilePicture
                              ? userProfilePicture
                              : userProfile
                          }
                          height={150}
                          width={150}
                        />
                      )}
                      {/* <img src={userProfile} height={150} width={150} /> */}
                    </Col>
                    <Col span={20}>
                      <Row>
                        <Col span={20}>
                          <b>{user?.userName}</b>
                        </Col>
                        <Col span={4}>
                          {checkIsInternalSourcing(user?.userRole) ? (
                            <span
                              className="edit-button"
                              onClick={onClickProfileEdit}
                            >
                              {t("EARNING_VIEW_DETAILS")}
                            </span>
                          ) : (
                            <span
                              className="edit-details"
                              // onClick={onClickProfileEdit}
                              onClick={() => {
                                onClickProfileEdit();
                                handleEditClick();
                              }}
                            >
                              <img
                                src={editIcon}
                                style={{ cursor: "pointer" }}
                                height={20}
                                width={20}
                              />{" "}
                              &nbsp;&nbsp;
                              <span className="edit-button">
                                {t("ACCOUNT_EDIT_DETAILS")}
                              </span>{" "}
                            </span>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {accountDetails?.countryCode}&nbsp;
                          {accountDetails?.mobileNo} &nbsp; {user?.emailId}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <b>{t("ACCOUNT_USER_TYPE")}:</b>{" "}
                          <span className="role-heading">
                            {/* {checkIsInternalSourcing(user?.userRole) ? "Internal Sourcer" :
                            checkIsFleetOwner(user?.userRole) ? "Fleet Owner" :
                              checkIsSTO(user?.userRole) ? OwnerType.STO : OwnerType.BROKER :
                              checkIsFleetOwnerC(user?.userRole) && "FleetOwner C"
                              } */}
                            {checkIsInternalSourcing(user?.userRole)
                              ? "Internal Sourcer"
                              : checkIsFleetOwner(user?.userRole)
                              ? "Fleet Owner"
                              : checkIsSTO(user?.userRole)
                              ? OwnerType.STO
                              : checkIsFleetOwnerConverted(user?.userRole)
                              ? "Fleet Owner C"
                              : OwnerType.BROKER}
                          </span>
                        </Col>
                      </Row>
                      <hr />
                      <Row>
                        <div>
                          <span>
                            <b>{t("ACCOUNT_ADDRESS")}</b>
                          </span>
                          <div>{accountDetails?.address?.location}</div>
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </div>
              {(user?.status === "Blocked" ||
                (checkIsSTO(user?.userRole) &&
                  accountDetails?.userKycStatus === "Approved")) && (
                <div style={{ margin: "1rem 0" }}>
                  <RequestToBroker
                    isSTOConvertedInBroker={
                      accountDetails?.isSTOConvertedInBroker ? true : false
                    }
                    userKycStatus={accountDetails?.userKycStatus}
                    refreshBasicInfo={refreshBasicInfo}
                    accountDetails={accountDetails}
                    submitHanlerFunction={submitHanlerFunction}
                  />
                </div>
              )}
              {kycDetailLoader && (
                <div style={{ margin: "1rem " }}>
                  <Spin style={{ marginLeft: "50%", marginTop: "10%" }}></Spin>
                </div>
              )}
              {!kycDetailLoader && !checkIsInternalSourcing(user?.userRole) && (
                <div style={{ margin: "1rem 0" }}>
                  {user?.userRole == OwnerType.FLEET_OWNER ||
                  user?.userRole == OwnerType.FLEET_OWNER_C ? (
                    <Row>
                      <Col md={9}>
                        <Card className="document-card">
                          <span>
                            <b>{t("ACCOUNT_DOCUMENTS")}</b>
                            &nbsp;&nbsp;&nbsp;
                            <b
                              className={
                                accountDetails?.userKycStatus === "Rejected"
                                  ? "reject-status"
                                  : accountDetails?.userKycStatus === "Approved"
                                  ? "approved-status"
                                  : "pending-status"
                              }
                            >
                              {accountDetails?.userKycStatus}
                            </b>
                          </span>
                          <hr />

                          <div
                            className={`documents-card ${
                              selectedDocumentType === "VatRegistration" ||
                              !selectedDocumentType
                                ? "selected"
                                : ""
                            }`}
                            onClick={() =>
                              setSelectedDocumentType("VatRegistration")
                            }
                            style={{
                              backgroundColor:
                                selectedDocumentType == "DriverLicense" &&
                                `rgba(${BrandColors.primaryRgb}, 0.1)`,
                            }}
                          >
                            <div>
                              <img src={ellipse} />{" "}
                              <img src={folder} className="folder-icon" />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "5px",
                              }}
                            >
                              <span>
                                <strong>
                                  {t("ACCOUNT_VAT_REGISTRATION_CERTIFICATE")}
                                </strong>
                              </span>
                              <span>
                                {user?.operatingCountry === "Kazakhstan"
                                  ? countNestedObjects(kycDetails?.tradeLicense)
                                  : countNestedObjects(
                                      kycDetails?.vatCertificate
                                    )}{" "}
                                document
                              </span>
                            </div>
                          </div>
                          {!isTurkeyKazakhstanPresent && (
                            <div
                              className={`documents-card ${
                                selectedDocumentType === "TradeLicense" ||
                                !selectedDocumentType
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                setSelectedDocumentType("TradeLicense")
                              }
                            >
                              <div>
                                <img src={ellipse} />{" "}
                                <img src={folder} className="folder-icon" />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "5px",
                                }}
                              >
                                <>
                                  <span>
                                    <strong>
                                      {t("ACCOUNT_TRADE_LICENSE")}
                                    </strong>
                                  </span>
                                  <span>
                                    {countNestedObjects(
                                      kycDetails?.tradeLicense
                                    )}{" "}
                                    {t("ACCOUNT_DOC")}
                                  </span>
                                </>
                              </div>
                            </div>
                          )}
                          {/* <div className={`documents-card ${selectedDocumentType === 'TradeLicense' ? "selected" :""}`}  onClick={()=>setSelectedDocumentType('TradeLicense')}><img src={ellipse} /> <img src={folder} className="folder-icon"/> {t("ACCOUNT_TRADE_LICENSE")}</div> */}
                        </Card>
                      </Col>
                      <Col md={15}>
                        <Card
                          className="document-card"
                          style={{
                            // height: "420px",
                            marginLeft: "1rem",
                            borderRadius: "16px",
                          }}
                        >
                          <span>
                            <b>
                              {selectedDocumentType === "TradeLicense"
                                ? "Trade License"
                                : t("ACCOUNT_VAT_REGISTRATION_CERTIFICATE")}
                            </b>
                          </span>
                          <hr />
                          {selectedDocumentType == "TradeLicense" ? (
                            <Row gutter={[16, 16]}>
                              <Col span={12}>
                                <Form>
                                  <Form.Item layout="vertical">
                                    {!isTurkeyKazakhstanPresent ? (
                                      <Fileupload
                                        entityId={""}
                                        entityType={EntityTypes.SUPPLIER}
                                        filetype={DocTypes.TRADE_LICENSE_FRONT}
                                        defaultFile={
                                          kycDetails?.tradeLicense?.frontDoc
                                            ?.documentPath
                                        }
                                        accessFile={false}
                                        defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                          kycDetails?.tradeLicense?.frontDoc
                                            ?.documentPathThumb
                                        )}
                                        readonly={true}
                                      />
                                    ) : null}
                                  </Form.Item>
                                </Form>
                              </Col>
                              <Col span={12}>
                                <Row gutter={[16, 16]}>
                                  <Col>
                                    <Row>
                                      <Col span={24}>
                                        <span className="document-heading">
                                          {t("ACCOUNT_TRADE_LICENSE")}
                                        </span>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <p>
                                          {isTurkeyKazakhstanPresent
                                            ? kycDetails?.iBanNo?.map(
                                                (e, index) => (
                                                  <>
                                                    {e}
                                                    {index <
                                                      kycDetails?.iBanNo
                                                        ?.length -
                                                        1 && <br />}
                                                  </>
                                                )
                                              )
                                            : kycDetails?.tradeLicense
                                                ?.documentNumber}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>

                                  {/* Inner Column 2 */}
                                  <Col>
                                    <Row>
                                      <Col span={24}>
                                        <span className="document-heading">
                                          {!isTurkeyKazakhstanPresent &&
                                            "Expiry Date"}
                                        </span>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <p>
                                          {!isTurkeyKazakhstanPresent &&
                                            dayjs(
                                              kycDetails?.tradeLicense
                                                ?.expiryDate
                                            ).format("DD/MM/YYYY")}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          ) : (
                            <Row gutter={[16, 16]}>
                              <Col span={12}>
                                <Form>
                                  <Form.Item layout="vertical">
                                    <Fileupload
                                      entityId={""}
                                      entityType={EntityTypes.SUPPLIER}
                                      filetype={DocTypes.VAT_FRONT}
                                      defaultFile={
                                        user.operatingCountry === "Kazakhstan"
                                          ? kycDetails?.tradeLicense?.frontDoc
                                              ?.documentPath
                                          : kycDetails?.vatCertificate?.frontDoc
                                              ?.documentPath
                                      }
                                      accessFile={false}
                                      defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                        user.operatingCountry === "Kazakhstan"
                                          ? kycDetails?.tradeLicense?.frontDoc
                                              ?.documentPathThumb
                                          : kycDetails?.vatCertificate?.frontDoc
                                              ?.documentPathThumb
                                      )}
                                      readonly={true}
                                    />
                                    {/* <Fileupload
                                    entityId={""}
                                    entityType={EntityTypes.SUPPLIER}
                                    filetype={DocTypes.VAT_FRONT}
                                    defaultFile={
                                      kycDetails?.vatCertificate?.frontDoc
                                        ?.documentPath
                                    }
                                    accessFile={false}
                                    defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                      kycDetails?.vatCertificate?.frontDoc
                                        ?.documentPathThumb
                                    )}
                                    readonly={true}
                                  /> */}
                                  </Form.Item>
                                </Form>
                              </Col>
                              <Col span={12}>
                                <Row gutter={[16, 16]}>
                                  <Col>
                                    <Row>
                                      <Col span={24}>
                                        <span className="document-heading">
                                          {t(
                                            "ACCOUNT_KYC_DETAILS_VAT_REGISTRATION_NO"
                                          )}
                                        </span>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <p>
                                          {user.operatingCountry ===
                                          "Kazakhstan"
                                            ? kycDetails?.tradeLicense
                                                ?.documentNumber
                                            : kycDetails?.vatCertificate
                                                ?.documentNumber}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>
                                  {/* Inner Column 2 */}
                                  <Col>
                                    <Row>
                                      <Col span={24}>
                                        <span className="document-heading">
                                          {t("SIGNUP_KYC_TRADE_LIC_EXPIRY")}
                                        </span>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <p>
                                          {/* { dayjs(kycDetails?.vatCertificate?.expiryDate).format('DD/MM/YYYY')} */}
                                          {user.operatingCountry ===
                                          "Kazakhstan"
                                            ? kycDetails?.tradeLicense
                                                ?.expiryDate
                                              ? dayjs(
                                                  kycDetails?.tradeLicense
                                                    ?.expiryDate
                                                ).format("DD/MM/YYYY")
                                              : "-"
                                            : dayjs(
                                                kycDetails?.vatCertificate
                                                  ?.expiryDate
                                              ).format("DD/MM/YYYY")}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                {isTurkeyKazakhstanPresent && (
                                  <>
                                    <Row>
                                      <Col span={12}>
                                        <span className="document-heading">
                                          {t("ACCOUNT_IBAN_NO")}
                                        </span>
                                        <p className="Iban-number">
                                          {isTurkeyKazakhstanPresent
                                            ? kycDetails?.iBanNo?.map(
                                                (e, index) => (
                                                  <>
                                                    <Tooltip title={e}>
                                                      {e}
                                                    </Tooltip>
                                                    {index <
                                                      kycDetails?.iBanNo
                                                        ?.length -
                                                        1 && <br />}
                                                  </>
                                                )
                                              )
                                            : kycDetails?.tradeLicense
                                                ?.documentNumber}
                                        </p>
                                      </Col>

                                      <Col span={12}>
                                        <span className="document-heading">
                                          {t("ACCOUNT_REG_OFFICE")}
                                        </span>
                                        <p>
                                          {isTurkeyKazakhstanPresent
                                            ? kycDetails?.registrationOffice
                                            : ""}
                                        </p>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col>
                                        <span className="document-heading">
                                          {t("ACCOUNT_CERTIFICATION")}
                                        </span>
                                        <p>{kycDetails?.certification[0]} </p>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                              </Col>
                            </Row>
                          )}
                        </Card>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col md={9}>
                        <Card
                          className="form-scroll-div"
                          style={{ height: "420px", borderRadius: "16px" }}
                        >
                          <span>
                            <b>{t("ACCOUNT_DOCUMENTS")}</b>
                            &nbsp;&nbsp;&nbsp;
                            <b
                              className={
                                accountDetails?.userKycStatus === "Rejected"
                                  ? "reject-status"
                                  : accountDetails?.userKycStatus === "Approved"
                                  ? "approved-status"
                                  : "pending-status"
                              }
                            >
                              {accountDetails?.userKycStatus}
                            </b>
                          </span>
                          <hr />

                          {/* <div className={`documents-card ${selectedDocumentType === "DriverLicense" || !selectedDocumentType ? "selected" : ""}`} onClick={() => setSelectedDocumentType('DriverLicense')}>
                          <div><img src={ellipse} />
                          <img src={folder} className="folder-icon" />
                          </div>
                          <div style={{display: 'flex', flexDirection: "column",gap:'5px'}}><span><strong>DriverLicense</strong></span>
                                <span>1 document</span>
                          </div>
                          
                      </div>

            <div className={`documents-card ${selectedDocumentType === 'Visa' ? "selected" :""}`}  onClick={()=>setSelectedDocumentType('Visa')}><img src={ellipse} /> <img src={folder} className="folder-icon"/>  <strong>Visa   </strong></div>
            <div className={`documents-card ${selectedDocumentType === "Passport" ? "selected":""}`} onClick={()=>setSelectedDocumentType('Passport')}><img src={ellipse}/> <img src={folder} className="folder-icon"/>   <strong>Passport   </strong></div>
            <div className={`documents-card ${selectedDocumentType === 'NationalID' ? "selected" :""}`}  onClick={()=>setSelectedDocumentType('NationalID')}><img src={ellipse} /> <img src={folder} className="folder-icon"/>   <strong>NationalID </strong></div>
                        */}
                          {documents.map((document) => (
                            <div
                              key={document.type}
                              className={`documents-card ${
                                selectedDocumentType === document.type
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                setSelectedDocumentType(document.type)
                              }
                            >
                              <div>
                                <img src={ellipse} alt="ellipse" />
                                <img
                                  src={folder}
                                  className="folder-icon"
                                  alt="folder"
                                />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "5px",
                                }}
                              >
                                <span>
                                  <strong>
                                    {document?.type == "DriverLicense"
                                      ? t("ACCOUNT_DRIVE_LICENCE")
                                      : document?.type == "NationalID"
                                      ? t("FLEET_DRIVER_NATIONAL_ID")
                                      : document?.type == "Visa"
                                      ? t("FLEET_DRIVER_VISA")
                                      : t("SIGNUP_KYC_PASSPORT_LIC_LBL")}
                                  </strong>
                                </span>
                                <span>
                                  {document?.type === "DriverLicense"
                                    ? countNestedObjects(
                                        kycDetails?.drivingLicense
                                      )
                                    : document?.type === "Visa"
                                    ? // ? countNestedObjects(kycDetails?.visa)
                                      kycDetails?.visa?.length
                                    : document?.type === "Passport"
                                    ? countNestedObjects(kycDetails?.passport)
                                    : document?.type === "NationalID"
                                    ? countNestedObjects(kycDetails?.nationalID)
                                    : 0}{" "}
                                  {t("ACCOUNT_DOC")}
                                </span>

                                {/* <span> {countNestedObjects(kycDetails?.document?.type)}  document</span> */}
                              </div>
                            </div>
                          ))}
                        </Card>
                      </Col>
                      <Col md={15}>
                        <Card
                          style={{
                            height: "420px",
                            marginLeft: "1rem",
                            borderRadius: "16px",
                            fontWeight: "700",
                          }}
                        >
                          <span>
                            <b>
                              {selectedDocumentType === "DriverLicense"
                                ? t("ACCOUNT_DRIVE_LICENCE")
                                : selectedDocumentType === "Visa"
                                ? t("FLEET_DRIVER_VISA")
                                : selectedDocumentType === "Passport"
                                ? t("SIGNUP_KYC_PASSPORT_LIC_LBL")
                                : selectedDocumentType === "NationalID"
                                ? t("FLEET_DRIVER_NATIONAL_ID")
                                : t("ACCOUNT_DRIVE_LICENCE")}
                            </b>
                          </span>
                          <hr />
                          {selectedDocumentType === "DriverLicense" && (
                            <Row gutter={[16, 16]}>
                              <Col span={12}>
                                <Form layout="vertical">
                                  <Form.Item>
                                    <Fileupload
                                      entityId={""}
                                      entityType={EntityTypes.SUPPLIER}
                                      filetype={DocTypes.DL_FRONT}
                                      defaultFile={
                                        kycDetails?.drivingLicense?.frontDoc
                                          ?.documentPath
                                      }
                                      accessFile={true}
                                      name={t("KYC_UPLOAD_FRONT_LBL")}
                                      defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                        kycDetails?.drivingLicense?.frontDoc
                                          ?.documentPathThumb
                                      )}
                                      readonly={true}
                                    />
                                  </Form.Item>
                                  <Form.Item>
                                    <Fileupload
                                      entityId={""}
                                      entityType={EntityTypes.SUPPLIER}
                                      filetype={DocTypes.DL_BACK}
                                      defaultFile={
                                        kycDetails?.drivingLicense?.backDoc
                                          ?.documentPath
                                      }
                                      accessFile={true}
                                      name={t("KYC_UPLOAD_BACK_LBL")}
                                      defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                        kycDetails?.drivingLicense?.backDoc
                                          ?.documentPathThumb
                                      )}
                                      readonly={true}
                                    />
                                  </Form.Item>
                                </Form>
                              </Col>
                              <Col span={12}>
                                <Row gutter={[16, 16]}>
                                  <Col>
                                    <Row>
                                      <Col span={24}>
                                        <span className="document-heading">
                                          {t("ACCOUNT_DRIVING_LICENCE_NO")}
                                        </span>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <Popover
                                          content={
                                            kycDetails?.drivingLicense
                                              ?.documentNumber
                                          }
                                        >
                                          <p className="ellipsis-text">
                                            {
                                              kycDetails?.drivingLicense
                                                ?.documentNumber
                                            }
                                          </p>
                                        </Popover>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col>
                                    <Row>
                                      <Col span={24}>
                                        <span className="document-heading">
                                          {t("ACCOUNT_KYC_DETAILS_EXPIRY_DATE")}
                                        </span>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <p>
                                          {dayjs(
                                            kycDetails?.drivingLicense
                                              ?.expiryDate
                                          ).format("DD/MM/YYYY")}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )}
                          {selectedDocumentType === "Visa" && (
                            <Row
                              style={{ height: "347px" }}
                              className="form-scroll-div"
                              gutter={[16, 16]}
                            >
                              {kycDetails?.visa?.map((visaItem, index) => (
                                <>
                                  <Col span={12}>
                                    <Form layout="vertical">
                                      <Form.Item>
                                        <Fileupload
                                          entityId={""}
                                          entityType={EntityTypes.SUPPLIER}
                                          filetype={DocTypes.VISA_FRONT}
                                          defaultFile={
                                            visaItem?.frontDoc?.documentPath
                                          }
                                          accessFile={false}
                                          defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                            visaItem?.frontDoc
                                              ?.documentPathThumb
                                          )}
                                          readonly={true}
                                        />
                                      </Form.Item>
                                    </Form>
                                  </Col>
                                  <Col span={12}>
                                    <Row gutter={[16, 16]}>
                                      <Col>
                                        <Row>
                                          <Col span={24}>
                                            <span className="document-heading">
                                              {t("ACCOUNT_KYC_DETAIL_VISA_NO")}
                                            </span>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col span={24}>
                                            <Popover
                                              content={visaItem?.documentNumber}
                                            >
                                              <p className="ellipsis-text-visa">
                                                {visaItem?.documentNumber}
                                              </p>
                                            </Popover>
                                          </Col>
                                        </Row>
                                      </Col>

                                      <Col>
                                        <Row>
                                          <Col span={24}>
                                            <span className="document-heading">
                                              {t("SIGNUP_KYC_TRADE_LIC_EXPIRY")}
                                            </span>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col span={24}>
                                            <p>
                                              {dayjs(
                                                visaItem?.expiryDate
                                              ).format("DD/MM/YYYY")}
                                            </p>
                                          </Col>
                                        </Row>
                                      </Col>

                                      <Col>
                                        <Row>
                                          <Col span={24}>
                                            <span className="document-heading">
                                              {t("ACCOUNT_ISSUNING_COUNTRY")}
                                            </span>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col span={24}>
                                            <p>{visaItem?.issuingCountry}</p>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Col>
                                </>
                              ))}
                            </Row>
                          )}
                          {selectedDocumentType === "Passport" && (
                            <Row gutter={[16, 16]}>
                              <Col span={12}>
                                <Form layout="vertical">
                                  <Form.Item>
                                    <Fileupload
                                      entityId={""}
                                      entityType={EntityTypes.SUPPLIER}
                                      filetype={DocTypes.PASSPORT_FRONT}
                                      defaultFile={
                                        kycDetails?.passport?.frontDoc
                                          ?.documentPath
                                      }
                                      accessFile={true}
                                      name={t("KYC_UPLOAD_FRONT_LBL")}
                                      defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                        kycDetails?.passport?.frontDoc
                                          ?.documentPathThumb
                                      )}
                                      readonly={true}
                                    />
                                  </Form.Item>

                                  <Form.Item>
                                    <Fileupload
                                      entityId={""}
                                      entityType={EntityTypes.SUPPLIER}
                                      filetype={DocTypes.PASSPORT_BACK}
                                      defaultFile={
                                        kycDetails?.passport?.backDoc
                                          ?.documentPath
                                      }
                                      accessFile={true}
                                      name={t("KYC_UPLOAD_BACK_LBL")}
                                      defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                        kycDetails?.passport?.backDoc
                                          ?.documentPathThumb
                                      )}
                                      readonly={true}
                                    />
                                  </Form.Item>
                                </Form>
                              </Col>
                              <Col span={12}>
                                <Row gutter={[16, 16]}>
                                  <Col>
                                    <Row>
                                      <Col span={24}>
                                        <span className="document-heading">
                                          {t("FLEET_DRIVER_PASSPORT_NO")}
                                        </span>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <Popover
                                          content={
                                            kycDetails?.passport?.documentNumber
                                          }
                                        >
                                          <p className="ellipsis-text">
                                            {
                                              kycDetails?.passport
                                                ?.documentNumber
                                            }
                                          </p>
                                        </Popover>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col>
                                    <Row>
                                      <Col span={24}>
                                        <span className="document-heading">
                                          {t("ACCOUNT_KYC_DETAILS_EXPIRY_DATE")}
                                        </span>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <p>
                                          {dayjs(
                                            kycDetails?.passport?.expiryDate
                                          ).format("DD/MM/YYYY")}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )}
                          {selectedDocumentType === "NationalID" &&
                          kycDetails?.nationalID ? (
                            <Row gutter={[16, 16]}>
                              <Col span={12}>
                                <Form layout="vertical">
                                  <Form.Item>
                                    <Fileupload
                                      entityId={""}
                                      entityType={EntityTypes.SUPPLIER}
                                      filetype={DocTypes.NATIONAL_ID_FRONT}
                                      defaultFile={
                                        kycDetails?.nationalID?.frontDoc
                                          ?.documentPath
                                      }
                                      accessFile={true}
                                      name={t("KYC_UPLOAD_FRONT_LBL")}
                                      defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                        kycDetails?.nationalID?.frontDoc
                                          ?.documentPathThumb
                                      )}
                                      readonly={true}
                                    />
                                  </Form.Item>

                                  <Form.Item>
                                    <Fileupload
                                      entityId={""}
                                      entityType={EntityTypes.SUPPLIER}
                                      filetype={DocTypes.NATIONAL_ID_BACK}
                                      defaultFile={
                                        kycDetails?.nationalID?.backDoc
                                          ?.documentPath
                                      }
                                      accessFile={true}
                                      name={t("KYC_UPLOAD_BACK_LBL")}
                                      defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                        kycDetails?.nationalID?.backDoc
                                          ?.documentPathThumb
                                      )}
                                      readonly={true}
                                    />
                                  </Form.Item>
                                </Form>
                              </Col>
                              <Col span={12}>
                                <Row gutter={[16, 16]}>
                                  <Col>
                                    <Row>
                                      <Col span={24}>
                                        <span className="document-heading">
                                          {t("ACCOUNT_NATIONAL_ID_NUMBER")}
                                        </span>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <Popover
                                          content={
                                            kycDetails?.nationalID
                                              ?.documentNumber
                                          }
                                        >
                                          <p className="ellipsis-text">
                                            {
                                              kycDetails?.nationalID
                                                ?.documentNumber
                                            }
                                          </p>
                                        </Popover>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col>
                                    <Row>
                                      <Col span={24}>
                                        <span className="document-heading">
                                          {t("SIGNUP_KYC_TRADE_LIC_EXPIRY")}
                                        </span>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <p>
                                          {dayjs(
                                            kycDetails?.nationalID?.expiryDate
                                          ).format("DD/MM/YYYY")}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          ) : (
                            " "
                          )}
                        </Card>
                      </Col>
                    </Row>
                  )}
                </div>
              )}
            </>
          ) : (
            <>
              <div style={{ margin: "1rem 0" }}>
                <Card style={{ height: "580px", width: "100%" }}>
                  <Row>
                    <Col span={19}>
                      <b className="basic-detail">
                        {t("ACCOUNT_BASIC_DETAILS")}
                      </b>
                    </Col>
                    <Col span={3}>
                      {!checkIsInternalSourcing(accountDetails?.userRole) && (
                        <Button
                          className="save-btn"
                          onClick={saveProfileDetails}
                          loading={saveProfileLoader}
                          disabled={saveKycDetailLoader}
                        >
                          {t("ACCOUNT_SAVE_CHANGES")}
                        </Button>
                      )}
                    </Col>
                    <Col span={2}>
                      <Button
                        style={{ marginLeft: "14%" }}
                        disabled={saveProfileLoader || saveKycDetailLoader}
                        // onClick={() => setProfileEditStatus(false)}
                        onClick={() => {
                          setProfileEditStatus(false);
                          setEditAccountDocs({});
                        }}
                      >
                        {checkIsInternalSourcing(accountDetails?.userRole)
                          ? t("ACCOUNT_DISCARD")
                          : t("ACCOUNT_DISCARD")}
                      </Button>
                    </Col>
                  </Row>
                  <hr />
                  <Row style={{ marginTop: "1rem" }}>
                    <Col span={2}>
                      {userDetailLoader ? (
                        <Spin
                          style={{ marginLeft: "25%", marginTop: "20%" }}
                        ></Spin>
                      ) : (
                        <img
                          src={
                            userProfilePicture
                              ? userProfilePicture
                              : userProfile
                          }
                          height={94}
                          width={94}
                        />
                      )}
                      {/* <img src={profileIcon} height={94} width={94} /> */}
                    </Col>
                    {!checkIsInternalSourcing(accountDetails?.userRole) && (
                      <Col>
                        <span style={{ marginTop: "1rem", marginLeft: "1rem" }}>
                          <b>{t("ACCOUNT_PROFILE_PICTURE")}</b>
                        </span>
                        <Row
                          style={{
                            marginTop: "0.5rem",
                            marginBottom: "0.5rem",
                            marginLeft: "1rem",
                          }}
                        >
                          <Col>
                            <Button
                              style={{ marginLeft: "0px" }}
                              disabled={
                                saveProfileLoader || saveKycDetailLoader
                              }
                              className="save-btn"
                              onClick={() => setIsUploadImage(true)}
                            >
                              <img src={uploadIcon} height={12} width={12} />
                              {/* {t("ACCOUNT_UPLOAD_IMAGE")} */}
                              {userProfilePicture
                                ? t("ACCOUNT_UPDATE_PROFILE")
                                : t("ACCOUNT_ADD_PROFILE")}
                            </Button>
                            {/* &nbsp;&nbsp;<Button>{t("ACCOUNT_REMOVE")}</Button> */}
                          </Col>
                        </Row>
                        <div style={{ fontSize: "12px", marginLeft: "1rem" }}>
                          {t("ACCOUNT_IMG_FORMAT_MSG")}
                        </div>
                      </Col>
                    )}
                  </Row>
                  <Row style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                    <Col>
                      <b>{t("ACCOUNT_USER_TYPE")}:</b>{" "}
                      <span className="role-heading">
                        {checkIsInternalSourcing(user?.userRole)
                          ? "Internal Sourcer"
                          : checkIsFleetOwner(user?.userRole)
                          ? "Fleet Owner"
                          : checkIsSTO(user?.userRole)
                          ? OwnerType.STO
                          : checkIsFleetOwnerConverted(user?.userRole)
                          ? "Fleet Owner C"
                          : OwnerType.BROKER}
                      </span>
                    </Col>

                    <Form
                      form={form}
                      name="basicDetailForm"
                      layout="vertical"
                      className="ant-form-basics"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="fullName"
                            className="floating-label-form-item"
                          >
                            <Input
                              placeholder={t("NAME_PLACEHOLDER")}
                              className="floating-input-basic"
                              onChange={handleNameChange}
                              onBlur={handleNameBlur}
                              value={accountDetails?.fullName}
                              disabled={checkIsInternalSourcing(user?.userRole)}
                            />
                            <label className="floating-label">
                              {t("ACCOUNT_BASIC_DETAILS_FULL_NAME")}
                              <b className="mandate-color">*</b>
                            </label>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            name="email"
                            className="floating-label-form-item"
                          >
                            <div className="styled-input-container">
                              <Input
                                ref={emailInputRef}
                                placeholder={t("EMAIL_ID_PLACEHOLDER")}
                                className="floating-input-basic editable-input"
                                // onChange={handleUserEmailChange}
                                onBlur={handleInputBlur}
                                // onFocus={() => setShowChangeText(false)}
                                value={accountDetails?.email}
                                disabled={checkIsInternalSourcing(
                                  user?.userRole
                                )}
                              />
                              {!checkIsInternalSourcing(
                                accountDetails?.userRole
                              ) &&
                                showChangeText && (
                                  <span
                                    className="styled-text"
                                    onClick={handleChangeTextClick}
                                  >
                                    {accountDetails?.email
                                      ? t("ACCOUNT_CHANGE")
                                      : t("LOADS_ADD")}
                                    {/* Change */}
                                  </span>
                                )}
                              <label className="floating-label">
                                {t("ACCOUNT_BASIC_DETAILS_EMAIL")}{" "}
                                {checkIsInternalSourcing(user?.userRole) && (
                                  <b className="mandate-color">*</b>
                                )}
                              </label>
                            </div>
                          </Form.Item>
                        </Col>

                        <Col span={2}>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: t("COUNTRY_CODE_REQUIRED"),
                              },
                            ]}
                            name="countryCode"
                            className="floating-label-form-item"
                          >
                            <Select
                              disabled={true}
                              showSearch
                              className="floating-select country-code-select"
                              popupClassName="country-code-popup"
                              placeholder="+355"
                              loading={mobileCountryCodeLoader}
                              // options={mobileCountryCodeList}
                              options={mobileCountryCodeList.map((item) => ({
                                ...item,
                                key: `${item.phone_code}-${
                                  item.country_code
                                }-${item.name.replace(/\s+/g, "")}`, // Unique key
                              }))}
                              fieldNames={{
                                label: "label",
                                value: "phone_code",
                              }}
                              filterOption={(input, option) =>
                                option?.searchKey?.includes(input.toLowerCase())
                              }
                              value={accountDetails?.countryCode}
                              onChange={phoneCodeSetter}
                            />
                            <label className="floating-label">
                              {t("ACCOUNT_BASIC_DETAILS_CC")}{" "}
                              <b className="mandate-color">*</b>
                            </label>
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="mobileNo"
                            className="floating-label-form-item"
                          >
                            <div className="styled-input-container">
                              <Input
                                ref={mobileInputRef}
                                value={accountDetails?.mobileNo}
                                placeholder={t("FORGOT_PH_MOBILE_NO")}
                                className="floating-input-basic editable-input"
                                // onChange={handleMobileNoChange}
                                onBlur={handleInputBlurMobileNo}
                                disabled={checkIsInternalSourcing(
                                  user?.userRole
                                )}
                                // onFocus={() => setShowChangeTextMobile(false)}
                              />
                              {!checkIsInternalSourcing(
                                accountDetails?.userRole
                              ) &&
                                showChangeTextMobile && (
                                  <span
                                    className="styled-text"
                                    onClick={handleChangeTextClickMobile}
                                  >
                                    {t("ACCOUNT_CHANGE")}
                                  </span>
                                )}
                              <label className="floating-label">
                                {" "}
                                {t("ACCOUNT_BASIC_DETAILS_MOBILE_NO")}{" "}
                                <b className="mandate-color">*</b>
                              </label>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>

                      <div style={{ margin: "15px" }}>
                        {" "}
                        {t("ACCOUNT_BASIC_DETAILS_ADDRESS")}{" "}
                      </div>
                      <Row gutter={[16, 16]} className="select-input">
                        <Col span={12}>
                          <Form.Item
                            name="country"
                            className="floating-label-form-item"
                          >
                            <Select
                              disabled={true}
                              className="floating-select"
                              options={countryOptions}
                              showSearch
                              placeholder={t("SIGNUP_BASIC_INFO_ADDRESS_PH")}
                              value={accountDetails?.country}
                              fieldNames={{ label: "name", value: "name" }}
                              // onChange={value => {form.setFieldsValue({ country: value })}}
                              onChange={handleCountryChange}
                              loading={countriesListWaiter}
                              filterOption={(input, option) =>
                                option.name
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            />
                            <label className="floating-label">
                              {t("ACCOUNT_BASIC_DETAILS_COUNTRY")}{" "}
                              <b className="mandate-color">*</b>
                            </label>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="city"
                            className="floating-label-form-item"
                          >
                            <AutoComplete
                              className="floating-select"
                              placeholder={t("SIGNUP_BASIC_INFO_ADDRESS_PH")}
                              showSearch
                              options={cityOptions}
                              fieldNames={{
                                label: "name",
                                value: "name",
                              }}
                              value={accountDetails?.city}
                              loading={cityOptionsWaiter}
                              onSelect={(val, option) =>
                                // handleSelectCity(val,option)
                                form.setFieldsValue({ city: option })
                              }
                              onChange={(val) => handleCityChange(val)}
                              // value={accountDetails?.city}
                              onSearch={(val) =>
                                val.length > 1 ? getCityList(val) : " "
                              }
                              filterOption={(input, option) =>
                                option.name
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              disabled={checkIsInternalSourcing(user?.userRole)}
                            />
                            <label className="floating-label">
                              {t("ACCOUNT_BASIC_DETAILS_CITY")}
                            </label>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <Form.Item
                            name="address"
                            className="floating-label-form-item"
                          >
                            <Placepicker
                              className="floating-input-basic"
                              defaultAdd={accountDetails?.address?.location}
                              onChange={handleLocationChange}
                              defaultLocation={{
                                lat: addressDetail.latitude,
                                lng: addressDetail.longitude,
                              }}
                              disabled={checkIsInternalSourcing(user?.userRole)}
                            />
                            <label className="floating-label">
                              {t("ACCOUNT_BASIC_DETAILS_ADDRESS")}
                            </label>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </Row>
                </Card>
                <br />
                {checkIsFleetOwner(accountDetails?.userRole) ||
                checkIsFleetOwnerConverted(user?.userRole) ? (
                  // <Card style={{ height: "400px", width: "100%" }}>
                  <Card style={{ width: "100%" }}>
                    <div className="kyc-details">
                      <div style={{ margin: "1rem" }}>
                        <b>{t("ACCOUNT_KYC_DETAILS")} </b>{" "}
                        <b
                          className={
                            accountDetails?.userKycStatus === "Rejected"
                              ? "reject-status"
                              : accountDetails?.userKycStatus === "Approved"
                              ? "approved-status"
                              : "pending-status"
                          }
                        >
                          {accountDetails?.userKycStatus}
                        </b>
                      </div>
                      <Button
                        loading={saveKycDetailLoader}
                        disabled={saveKycDetailLoader || saveProfileLoader}
                        className="save-btn"
                        onClick={saveProfileDetailsKYC}
                      >
                        {t("ACCOUNT_SAVE_KYC_CHANGES")}
                      </Button>
                    </div>
                    <Form
                      form={kycForm}
                      name="kycForm"
                      layout="vertical"
                      className="ant-form-basics"
                    >
                      {!isTurkeyKazakhstanPresent && (
                        <Row gutter={[16, 16]}>
                          <Col span={12}>
                            {/* <Form.Item name="vatUpload" className="floating-label-form-item"
                          rules={[
                            { required: true, message: t("ACCOUNT_VAT_UPLOAD_REQUEST_MSG") },
                          ]}>
                          <Fileupload
                            filetype={DocTypes.VAT_FRONT}
                            defaultThumbFile={documentUtility?.getThumbnailImagePath(
                              kycForm.getFieldValue("vatUpload")?.fileThumbUrl
                            )}
                            defaultFile={kycForm.getFieldValue("vatUpload")?.fileUrl}
                            fileName={kycForm.getFieldValue("vatUpload")?.fileName}
                            entityId=""
                            entityType={EntityTypes.SUPPLIER}
                            accessFile={false}
                            onChange={(value) => {
                              onFileUploadDocs(value, "vatUpload");
                              //kycForm.setFieldsValue({ vatUpload: value });
                            }}
                          // updateFormValue={(val) => {
                          //   kycForm.setFieldsValue({ vatUpload: val });
                          // }}
                          />
                        </Form.Item> */}

                            {/* **** OCR File Upload Vat Registration Certificate ***** */}
                            <Form.Item
                              className="floating-label-form-item"
                              name="vatUpload"
                              rules={[
                                {
                                  required: true,
                                  message: t("ACCOUNT_VAT_UPLOAD_REQUEST_MSG"),
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              <OCRFilePreviewUploader
                                filetype={DocTypes.VAT_FRONT}
                                defaultThumbFile={
                                  editAccoutDocs?.vatCertificate?.frontDoc
                                    ?.documentPathThumb
                                }
                                defaultFile={
                                  editAccoutDocs?.vatCertificate?.frontDoc
                                    ?.documentPath
                                }
                                fileName={
                                  editAccoutDocs?.vatCertificate?.frontDoc
                                    ?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={false}
                                onChange={(newFiles) =>
                                  handleOCRConformFileChange(
                                    newFiles,
                                    "vatUpload",
                                    OCRFieldNames.VAT_CERTIFICATE,
                                    DocTypes.VAT_FRONT
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "vatUpload",
                                    OCRFieldNames.VAT_CERTIFICATE
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              name="vatNumber"
                              rules={[
                                {
                                  required: true,
                                  message: t("ACCOUNT_VAT_REGISTATION_MSG"),
                                },
                                uniqueDocNumberRule(['tradeLicenseNumber'])
                              ]}
                              className="floating-label-form-item"
                            >
                              <Input
                                placeholder={t("SIGNUP_KYC_VAT_REG_NUM_PH")}
                                value={kycFormValues?.vatNumber}
                                //  value={kycDetails.vatNumber}
                                className="floating-input-basic"
                                maxLength={20}
                                onChange={(e) =>
                                  handleFormChange("vatNumber", e.target.value)
                                }
                              />
                              <span className="floating-label">
                                {t("ACCOUNT_KYC_DETAILS_VAT_REGISTRATION_NO")}{" "}
                                <b className="mandate-color">*</b>
                              </span>
                            </Form.Item>

                            <Form.Item
                              name="vatExpiry"
                              rules={[
                                {
                                  required: true,
                                  message: t("ACCOUNT_SELECT_EXP_MSG"),
                                },
                              ]}
                              className="floating-label-form-item"
                            >
                              <DatePicker
                                className="floating-input-basic"
                                format={format}
                                value={
                                  kycFormValues?.vatExpiry
                                    ? dayjs(kycFormValues.vatExpiry, format)
                                    : null
                                }
                                style={{ fontSize: "12px" }}
                                disabledDate={disablePastDates}
                                placeholder={t("SIGNUP_KYC_VAT_REG_EXPIRY_PH")}
                                onChange={(date, dateString) =>
                                  handleFormChange("vatExpiry", dateString)
                                }
                              />
                              <label className="floating-label">
                                {t("ACCOUNT_KYC_DETAILS_EXPIRY_DATE")}{" "}
                                <b className="mandate-color">*</b>
                              </label>
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      {isTurkeyKazakhstanPresent && (
                        <Row gutter={[16, 16]}>
                          {user?.operatingCountry === "Kazakhstan" ? (
                            <>
                              <Col span={12}>
                                {/* <Form.Item
                                  name="tradeLicenseUpload"
                                  className="floating-label-form-item"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("TRADE_DOC_UPLOAD_REQUIRED"),
                                    },
                                  ]}
                                >
                                  <Fileupload
                                    filetype={DocTypes.TRADE_LICENSE_FRONT}
                                    defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                      kycForm.getFieldValue(
                                        "tradeLicenseUpload"
                                      )?.fileThumbUrl
                                    )}
                                    defaultFile={
                                      kycForm.getFieldValue(
                                        "tradeLicenseUpload"
                                      )?.fileUrl
                                    }
                                    fileName={
                                      kycForm.getFieldValue(
                                        "tradeLicenseUpload"
                                      )?.fileName
                                    }
                                    entityId=""
                                    entityType={EntityTypes.SUPPLIER}
                                    accessFile={false}
                                    onChange={(value) => {
                                      onFileUploadDocs(
                                        value,
                                        "tradeLicenseUpload"
                                      );
                                      //kycForm.setFieldsValue({ vatUpload: value });
                                    }}
                                    // updateFormValue={(val) => {
                                    //   kycForm.setFieldsValue({ vatUpload: val });
                                    // }}
                                  />
                                </Form.Item> */}
                                {/* **************** OCR File Upload TRADE Certificate *********** */}
                                <Form.Item
                                  className="floating-label-form-item"
                                  name="tradeLicenseUpload"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("TRADE_DOC_UPLOAD_REQUIRED"),
                                    },
                                  ]}
                                  valuePropName="value"
                                  getValueFromEvent={(e) => {
                                    // if your component emits [ { file, fileThumbUrl } ]
                                    if (Array.isArray(e) && e.length > 0) {
                                      return {
                                        // File: e[0].file,
                                        // FileThumbURL: e[0].fileThumbUrl,
                                      };
                                    }
                                    return e;
                                  }}
                                >
                                  {/* ocr */}
                                  <OCRFilePreviewUploader
                                    filetype={DocTypes.TRADE_LICENSE_FRONT}
                                    defaultThumbFile={
                                      editAccoutDocs?.tradeLicense?.frontDoc
                                        ?.documentPathThumb
                                    }
                                    defaultFile={
                                      editAccoutDocs?.tradeLicense?.frontDoc
                                        ?.documentPath
                                    }
                                    fileName={
                                      editAccoutDocs?.tradeLicense?.frontDoc
                                        ?.fileName
                                    }
                                    entityId=""
                                    entityType={EntityTypes.SUPPLIER}
                                    accessFile={false}
                                    onChange={(newFiles) =>
                                      handleOCRConformFileChange(
                                        newFiles,
                                        "tradeLicenseUpload",
                                        OCRFieldNames.TRADE_LICENSE,
                                        DocTypes.TRADE_LICENSE_FRONT
                                      )
                                    }
                                    onDelete={() =>
                                      handleEditingDeleteFile(
                                        "tradeLicenseUpload",
                                        OCRFieldNames.TRADE_LICENSE
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  name="tradeLicenseNumber"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("TRADE_REG_NO_REQUIRED"),
                                    },
                                    uniqueDocNumberRule(['tradeLicenseNumber'])
                                  ]}
                                  className="floating-label-form-item"
                                >
                                  <Input
                                    placeholder={t(
                                      "ACCOUNT_TRADE_REGISTRATION_MSG"
                                    )}
                                    value={kycFormValues?.tradeLicenseNumber}
                                    //  value={kycDetails.vatNumber}
                                    className="floating-input-basic"
                                    maxLength={20}
                                    onChange={(e) =>
                                      handleFormChange(
                                        "tradeLicenseNumber",
                                        e.target.value
                                      )
                                    }
                                  />
                                  <span className="floating-label">
                                    {t("ACCOUNT_TRADE_REGISTRATION_NO")}{" "}
                                    <b className="mandate-color">*</b>
                                  </span>
                                </Form.Item>

                                <Form.Item
                                  name="tradeExpiry"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("ACCOUNT_SELECT_EXP_MSG"),
                                    },
                                  ]}
                                  className="floating-label-form-item"
                                >
                                  <DatePicker
                                    className="floating-input-basic"
                                    format={format}
                                    value={
                                      kycFormValues?.tradeExpiry
                                        ? dayjs(
                                            kycFormValues.tradeExpiry,
                                            format
                                          )
                                        : null
                                    }
                                    style={{ fontSize: "12px" }}
                                    disabledDate={disablePastDates}
                                    placeholder={t(
                                      "SIGNUP_KYC_VAT_REG_EXPIRY_PH"
                                    )}
                                    onChange={(date, dateString) =>
                                      handleFormChange(
                                        "tradeExpiry",
                                        dateString
                                      )
                                    }
                                  />
                                  <label className="floating-label">
                                    {t("ACCOUNT_KYC_DETAILS_EXPIRY_DATE")}{" "}
                                    <b className="mandate-color">*</b>
                                  </label>
                                </Form.Item>
                              </Col>{" "}
                            </>
                          ) : (
                            <>
                              <Col span={12}>
                                {/* <Form.Item
                                  name="vatUpload"
                                  className="floating-label-form-item"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("VAT_DOC_UPLOAD_REQUIRED"),
                                    },
                                  ]}
                                >
                                  <Fileupload
                                    filetype={DocTypes.VAT_FRONT}
                                    defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                      kycForm.getFieldValue("vatUpload")
                                        ?.fileThumbUrl
                                    )}
                                    defaultFile={
                                      kycForm.getFieldValue("vatUpload")
                                        ?.fileUrl
                                    }
                                    fileName={
                                      kycForm.getFieldValue("vatUpload")
                                        ?.fileName
                                    }
                                    entityId=""
                                    entityType={EntityTypes.SUPPLIER}
                                    accessFile={false}
                                    onChange={(value) => {
                                      onFileUploadDocs(value, "vatUpload");
                                      //kycForm.setFieldsValue({ vatUpload: value });
                                    }}
                                    // updateFormValue={(val) => {
                                    //   kycForm.setFieldsValue({ vatUpload: val });
                                    // }}
                                  />
                                </Form.Item> */}

                                {/* **** OCR File Upload Vat Registration Certificate ***** */}
                                <Form.Item
                                  className="floating-label-form-item"
                                  name="vatUpload"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("VAT_DOC_UPLOAD_REQUIRED"),
                                    },
                                  ]}
                                  valuePropName="value"
                                  getValueFromEvent={(e) => {
                                    // if your component emits [ { file, fileThumbUrl } ]
                                    if (Array.isArray(e) && e.length > 0) {
                                      return {
                                        // File: e[0].file,
                                        // FileThumbURL: e[0].fileThumbUrl,
                                      };
                                    }
                                    return e;
                                  }}
                                >
                                  <OCRFilePreviewUploader
                                    filetype={DocTypes.VAT_FRONT}
                                    defaultThumbFile={
                                      editAccoutDocs?.vatCertificate?.frontDoc
                                        ?.documentPathThumb
                                    }
                                    defaultFile={
                                      editAccoutDocs?.vatCertificate?.frontDoc
                                        ?.documentPath
                                    }
                                    fileName={
                                      editAccoutDocs?.vatCertificate?.frontDoc
                                        ?.fileName
                                    }
                                    entityId=""
                                    entityType={EntityTypes.SUPPLIER}
                                    accessFile={false}
                                    onChange={(newFiles) =>
                                      handleOCRConformFileChange(
                                        newFiles,
                                        "vatUpload",
                                        OCRFieldNames.VAT_CERTIFICATE,
                                        DocTypes.VAT_FRONT
                                      )
                                    }
                                    onDelete={() =>
                                      handleEditingDeleteFile(
                                        "vatUpload",
                                        OCRFieldNames.VAT_CERTIFICATE
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  name="vatNumber"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("ACCOUNT_VAT_REGISTATION_MSG"),
                                    },
                                    uniqueDocNumberRule(["vatNumber"]),
                                  ]}
                                  className="floating-label-form-item"
                                >
                                  <Input
                                    placeholder={t("SIGNUP_KYC_VAT_REG_NUM_PH")}
                                    value={kycFormValues?.vatNumber}
                                    //  value={kycDetails.vatNumber}
                                    className="floating-input-basic"
                                    maxLength={20}
                                    onChange={(e) =>
                                      handleFormChange(
                                        "vatNumber",
                                        e.target.value
                                      )
                                    }
                                  />
                                  <span className="floating-label">
                                    {t(
                                      "ACCOUNT_KYC_DETAILS_VAT_REGISTRATION_NO"
                                    )}{" "}
                                    <b className="mandate-color">*</b>
                                  </span>
                                </Form.Item>

                                <Form.Item
                                  name="vatExpiry"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("EXPIRY_DATE_REQUIRED"),
                                    },
                                  ]}
                                  className="floating-label-form-item"
                                >
                                  <DatePicker
                                    className="floating-input-basic"
                                    format={format}
                                    value={
                                      kycFormValues?.vatExpiry
                                        ? dayjs(kycFormValues.vatExpiry, format)
                                        : null
                                    }
                                    style={{ fontSize: "12px" }}
                                    disabledDate={disablePastDates}
                                    placeholder={t(
                                      "SIGNUP_KYC_VAT_REG_EXPIRY_PH"
                                    )}
                                    onChange={(date, dateString) =>
                                      handleFormChange("vatExpiry", dateString)
                                    }
                                  />
                                  <label className="floating-label">
                                    {t("ACCOUNT_KYC_DETAILS_EXPIRY_DATE")}{" "}
                                    <b className="mandate-color">*</b>
                                  </label>
                                </Form.Item>
                              </Col>
                            </>
                          )}
                        </Row>
                      )}

                      <br />

                      <Row gutter={[16, 16]}>
                        <Col span={12}>
                          {!isTurkeyKazakhstanPresent ? (
                            // <Form.Item
                            //   name="tradeLicenseUpload"
                            //   className="floating-label-form-item"
                            //   rules={[
                            //     {
                            //       required: true,
                            //       message: t(
                            //         "ACCOUNT_TRADE_UPLOAD_REQUEST_MSG"
                            //       ),
                            //     },
                            //   ]}
                            // >
                            //   <Fileupload
                            //     defaultThumbFile={documentUtility?.getThumbnailImagePath(
                            //       kycForm.getFieldValue("tradeLicenseUpload")
                            //         ?.fileThumbUrl
                            //     )}
                            //     defaultFile={
                            //       kycForm.getFieldValue("tradeLicenseUpload")
                            //         ?.fileUrl
                            //     }
                            //     filetype={DocTypes.TRADE_LICENSE_FRONT}
                            //     fileName={
                            //       kycForm.getFieldValue("tradeLicenseUpload")
                            //         ?.fileName
                            //     }
                            //     entityId=""
                            //     entityType={EntityTypes.SUPPLIER}
                            //     accessFile={false}
                            //     onChange={(value) => {
                            //       onFileUploadDocs(value, "tradeLicenseUpload");
                            //       //kycForm.setFieldsValue({ tradeLicenseUpload: value });
                            //     }}
                            //     // updateFormValue={(val) => {
                            //     //   kycForm.setFieldsValue({ tradeLicenseUpload: val });
                            //     // }}
                            //   />
                            // </Form.Item>

                            /* **************** OCR File Upload TRADE Certificate *********** */
                            <Form.Item
                              className="floating-label-form-item"
                              name="tradeLicenseUpload"
                              rules={[
                                {
                                  required: true,
                                  message: t(
                                    "ACCOUNT_TRADE_UPLOAD_REQUEST_MSG"
                                  ),
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              {/* ocr */}
                              <OCRFilePreviewUploader
                                filetype={DocTypes.TRADE_LICENSE_FRONT}
                                defaultThumbFile={
                                  editAccoutDocs?.tradeLicense?.frontDoc
                                    ?.documentPathThumb
                                }
                                defaultFile={
                                  editAccoutDocs?.tradeLicense?.frontDoc
                                    ?.documentPath
                                }
                                fileName={
                                  editAccoutDocs?.tradeLicense?.frontDoc
                                    ?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={false}
                                onChange={(newFiles) =>
                                  handleOCRConformFileChange(
                                    newFiles,
                                    "tradeLicenseUpload",
                                    OCRFieldNames.TRADE_LICENSE,
                                    DocTypes.TRADE_LICENSE_FRONT
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "tradeLicenseUpload",
                                    OCRFieldNames.TRADE_LICENSE
                                  )
                                }
                              />
                            </Form.Item>
                          ) : (
                            ibanNumber?.map((ele, index) => (
                              <>
                                <Form.Item
                                  // name={`vatRegistration_${index}`}
                                  name="iBanNo"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("ACCOUNT_ENTER_IBAN_NO"),
                                    },
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        const ibanlength =
                                          user?.operatingCountry ===
                                          "Kazakhstan"
                                            ? 20
                                            : user?.operatingCountry ===
                                              "Turkey"
                                            ? 26
                                            : 34;
                                        if (!value) {
                                          return Promise.reject(
                                            t("IBAN_REQUIRED")
                                          );
                                        }
                                        if (value.length !== ibanlength) {
                                          return Promise.reject(
                                            `${t(
                                              "IBAN_LENGTH_REQUIRED"
                                            )} ${ibanlength} `
                                          );
                                        }
                                        return Promise.resolve();
                                      },
                                    }),
                                  ]}
                                  className="floating-label-form-item"
                                >
                                  <Input
                                    value={kycFormValues?.iBanNo[index]}
                                    placeholder={t("IBAN_PLACEHOLDER")}
                                    className="floating-input"
                                    maxLength={
                                      accountDetails?.country === "Kazakhstan"
                                        ? 20
                                        : accountDetails?.country === "Turkey"
                                        ? 26
                                        : 34
                                    }
                                    onChange={(e) => {
                                      const updatedIbanNumbers = [
                                        ...kycFormValues?.iBanNo,
                                      ];
                                      setIbanNumber(updatedIbanNumbers);
                                      updatedIbanNumbers[index] =
                                        e.target.value;
                                      setKycFormValues({
                                        ...kycFormValues,
                                        iBanNo: updatedIbanNumbers, // Update form values with the new IBAN
                                      });
                                      kycForm?.setFieldValue(
                                        "iBanNo",
                                        updatedIbanNumbers[index]
                                      ); // Update form field value
                                    }}
                                  />
                                  <label className="floating-label">
                                    {t("ACCOUNT_IBAN_NO")}
                                    <b className="mandate-color">*</b>
                                  </label>
                                </Form.Item>
                              </>
                            ))
                          )}

                          {isTurkeyKazakhstanPresent && (
                            <Row gutter={16}>
                              <Col span={16}>
                                <label className="registration-lable">
                                  {t("MUST_BE_KEY")}{" "}
                                  {accountDetails?.country === "Kazakhstan"
                                    ? "20"
                                    : accountDetails?.country === "Turkey"
                                    ? "26"
                                    : "34"}{" "}
                                  {t("ACCOUNT_DIGITS")}
                                </label>
                              </Col>
                              <Col span={8}>
                                <Button
                                  type="secondary"
                                  icon={<PlusOutlined />}
                                  className="add-doc"
                                  onClick={addIbanNumber}
                                >
                                  {t("ACCOUNT_ADD_IBAN")}
                                </Button>
                              </Col>
                            </Row>
                          )}
                        </Col>
                        <Col span={12}>
                          {!isTurkeyKazakhstanPresent ? (
                            <>
                              <Form.Item
                                name="tradeLicenseNumber"
                                className="floating-label-form-item"
                                rules={[
                                  {
                                    required: true,
                                    message: t(
                                      "ACCOUNT_TRADE_REGISTRATION_MSG"
                                    ),
                                  },
                                  uniqueDocNumberRule(["vatNumber"]),
                                ]}
                              >
                                <Input
                                  value={kycFormValues?.tradeLicenseNumber}
                                  placeholder={t("SIGNUP_KYC_TRADE_LIC_NUM_PH")}
                                  className="floating-input-basic"
                                  maxLength={20}
                                  onChange={(e) =>
                                    handleFormChange(
                                      "tradeLicenseNumber",
                                      e.target.value
                                    )
                                  }
                                />
                                <label className="floating-label">
                                  {t("ACCOUNT_KYC_DETAILS_TRADE_LICENSE_NO")}{" "}
                                  <b className="mandate-color">*</b>
                                </label>
                              </Form.Item>

                              <Form.Item
                                name="tradeExpiry"
                                rules={[
                                  {
                                    required: true,
                                    message: t("ACCOUNT_SELECT_EXP_MSG"),
                                  },
                                ]}
                                className="floating-label-form-item"
                              >
                                <DatePicker
                                  className="floating-input-basic"
                                  format={format}
                                  style={{ fontSize: "12px" }}
                                  value={
                                    kycFormValues?.tradeExpiry
                                      ? dayjs(kycFormValues.tradeExpiry, format)
                                      : null
                                  }
                                  disabledDate={disablePastDates}
                                  placeholder={t(
                                    "SIGNUP_KYC_VAT_REG_EXPIRY_PH"
                                  )}
                                  onChange={(date, dateString) =>
                                    handleFormChange("tradeExpiry", dateString)
                                  }
                                />
                                <label className="floating-label">
                                  {t("SIGNUP_KYC_VAT_REG_EXPIRY")}{" "}
                                  <b className="mandate-color">*</b>
                                </label>
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name="registrationOffice"
                                rules={[
                                  {
                                    required: true,
                                    message: t("REGISTRATION_OFFICE_REQUIRED"),
                                  },
                                ]}
                                className="floating-label-form-item"
                              >
                                <Input
                                  value={kycFormValues?.registrationOffice}
                                  placeholder={t("ACCOUNT_ENTER_REG_OFFICE")}
                                  className="floating-input"
                                  onChange={(e) =>
                                    handleFormChange(
                                      "registrationOffice",
                                      e.target.value
                                    )
                                  }
                                />
                                <label className="floating-label">
                                  {t("ACCOUNT_REG_OFFICE")}
                                  <b className="mandate-color">*</b>
                                </label>
                              </Form.Item>
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: t(
                                      "ACCOUNT_SELECT_CERTIFICATION_MSG"
                                    ),
                                  },
                                ]}
                                name="certification"
                                className="floating-label-form-item"
                              >
                                <Select
                                  options={[
                                    { label: "K1", value: "K1" },
                                    { label: "C2", value: "C2" },
                                  ]}
                                  value={kycForm?.getFieldValue(
                                    "certification"
                                  )}
                                  onChange={(value) => {
                                    handleFormChange("certification", value);
                                  }}
                                  style={{ width: "100%", height: "56px" }}
                                />
                                <label className="floating-label">
                                  {t("ACCOUNT_CERTIFICATION")}
                                  <b className="mandate-color">*</b>
                                </label>
                              </Form.Item>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form>
                  </Card>
                ) : (
                  !checkIsInternalSourcing(user?.userRole) && (
                    <Card style={{ width: "100%" }}>
                      <div className="kyc-details">
                        <div style={{ margin: "1rem" }}>
                          <b>{t("ACCOUNT_KYC_DETAILS")} </b>{" "}
                          <b
                            className={
                              accountDetails?.userKycStatus === "Rejected"
                                ? "reject-status"
                                : accountDetails?.userKycStatus === "Approved"
                                ? "approved-status"
                                : "pending-status"
                            }
                          >
                            {accountDetails?.userKycStatus}
                          </b>
                        </div>
                        {!checkIsInternalSourcing(accountDetails?.userRole) && (
                          <Button
                            loading={saveKycDetailLoader}
                            disabled={saveKycDetailLoader || saveProfileLoader}
                            className="save-btn"
                            onClick={saveProfileDetailsKYC}
                          >
                            {t("ACCOUNT_SAVE_KYC_CHANGES")}
                          </Button>
                        )}
                      </div>
                      <Form
                        form={kycForm}
                        name="kycForm"
                        layout="vertical"
                        className="ant-form-basics"
                      >
                        {" "}
                        <Row>
                          <Row>
                            <b>{t("SIGNUP_KYC_DRIVING_LIC_HEADER")}</b>
                          </Row>
                        </Row>
                        <Row gutter={[16, 16]}>
                          <Col span={6}>
                            {/* Driving License */}
                            {/* <Form.Item
                              name="licenceFront"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("UPLOAD_LICENCE_FRONT_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                            >
                              
                              <Fileupload
                                defaultThumbFile={documentUtility.getThumbnailImagePath(
                                  kycForm.getFieldValue("licenceFront")
                                    ?.fileThumbUrl
                                )}
                                defaultFile={
                                  kycForm.getFieldValue("licenceFront")?.fileUrl
                                }
                                filetype={DocTypes?.DL_FRONT}
                                fileName={
                                  kycForm.getFieldValue("licenceFront")
                                    ?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={true}
                                name={t("KYC_UPLOAD_FRONT_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "licenceFront");
                                  // kycForm.setFieldsValue({ vatUpload: value });
                                }}
                                // updateFormValue={(val) => {
                                //   kycForm.setFieldsValue({ vatUpload: val });
                                // }}
                              />
                            </Form.Item> */}

                            {/* **************** OCR File Upload Driving License FRONT *********** */}
                            <Form.Item
                              className="floating-label-form-item"
                              name="licenceFront"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("UPLOAD_LICENCE_FRONT_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              {/* ocr */}
                              <OCRFilePreviewUploader
                                filetype={DocTypes.DL_FRONT}
                                defaultThumbFile={
                                  editAccoutDocs?.drivingLicense?.frontDoc
                                    ?.documentPathThumb
                                }
                                defaultFile={
                                  editAccoutDocs?.drivingLicense?.frontDoc
                                    ?.documentPath
                                }
                                fileName={
                                  editAccoutDocs?.drivingLicense?.frontDoc
                                    ?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={false}
                                onChange={(newFiles) =>
                                  handleOCRConformFileChange(
                                    newFiles,
                                    "licenceFront",
                                    OCRFieldNames.DRIVING_LICENSE,
                                    DocTypes.DL_FRONT
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "licenceFront",
                                    OCRFieldNames.DRIVING_LICENSE
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col span={6}>
                            {/* <Form.Item
                              name="licenceBack"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("UPLOAD_LICENCE_BACK_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                            >
                              <Fileupload
                                defaultThumbFile={documentUtility.getThumbnailImagePath(
                                  kycForm.getFieldValue("licenceBack")
                                    ?.fileThumbUrl
                                )}
                                defaultFile={
                                  kycForm.getFieldValue("licenceBack")?.fileUrl
                                }
                                filetype={DocTypes?.DL_BACK}
                                fileName={
                                  kycForm.getFieldValue("licenceBack")?.fileName
                                }
                                entityId={""}
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={true}
                                name={t("KYC_UPLOAD_BACK_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "licenceBack");
                                  //kycForm.setFieldsValue({ vatUpload: value });
                                }}
                                // updateFormValue={(val) => {
                                //   kycForm.setFieldsValue({ vatUpload: val });
                                // }}
                              />
                            </Form.Item> */}
                            {/* **************** OCR File Upload Driving License BACK *********** */}
                            <Form.Item
                              className="floating-label-form-item"
                              name="licenceBack"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("UPLOAD_LICENCE_BACK_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              {/* ocr */}
                              <OCRFilePreviewUploader
                                filetype={DocTypes.DL_BACK}
                                defaultThumbFile={
                                  editAccoutDocs?.drivingLicense?.backDoc
                                    ?.documentPathThumb
                                }
                                defaultFile={
                                  editAccoutDocs?.drivingLicense?.backDoc
                                    ?.documentPath
                                }
                                fileName={
                                  editAccoutDocs?.drivingLicense?.backDoc
                                    ?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={false}
                                onChange={(newFiles) =>
                                  handleOCRConformFileChange(
                                    newFiles,
                                    "licenceBack",
                                    OCRFieldNames.DRIVING_LICENSE,
                                    DocTypes.DL_BACK
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "licenceBack",
                                    OCRFieldNames.DRIVING_LICENSE
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              name="driverLicenseNumber"
                              rules={[
                                {
                                  required: true,
                                  message: t("ACCOUNT_DRIVER_LICENCE_NO"),
                                },
                                uniqueDocNumberRule("driverLicenseNumber"),
                              ]}
                              className="floating-label-form-item"
                            >
                              <Input
                                placeholder={t("SIGNUP_KYC_DRIVING_LIC_PH")}
                                value={kycFormValues.driverLicenseNumber}
                                //  value={kycDetails.vatNumber}
                                className="floating-input-basic"
                                maxLength={20}
                                onChange={(e) =>
                                  handleFormChange(
                                    "driverLicenseNumber",
                                    e.target.value
                                  )
                                }
                              />
                              {/* <span className="floating-label">{t("SIGNUP_KYC_VAT_REG_NUM")} *</span> */}
                              <span className="floating-label">
                                {t("ACCOUNT_KYC_DETAILS_DRIVING_LICENSE_NO")}{" "}
                                <b className="mandate-color">*</b>
                              </span>
                            </Form.Item>

                            <Form.Item
                              name="driverExpiry"
                              rules={[
                                {
                                  required: true,
                                  message: t("ACCOUNT_SELECT_EXP_MSG"),
                                },
                              ]}
                              className="floating-label-form-item"
                            >
                              <DatePicker
                                className="floating-input-basic"
                                value={
                                  kycFormValues?.driverExpiry
                                    ? dayjs(kycFormValues.driverExpiry, format)
                                    : null
                                }
                                style={{ fontSize: "12px" }}
                                disabledDate={disablePastDates}
                                format={format}
                                placeholder={t("SIGNUP_KYC_VAT_REG_EXPIRY_PH")}
                                onChange={(date, dateString) =>
                                  handleFormChange("driverExpiry", dateString)
                                }
                              />
                              <label className="floating-label">
                                {t("SIGNUP_KYC_VAT_REG_EXPIRY")}{" "}
                                <b className="mandate-color">*</b>
                              </label>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Row>
                            <b>{t("SIGNUP_KYC_PASSPORT_LIC_LBL")}</b>
                          </Row>
                        </Row>
                        {/* Passport */}
                        <Row gutter={[16, 16]}>
                          <Col span={6}>
                            {/* <Form.Item
                              name="passportFront"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("PASSPORT_FRONT_UPLOAD_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                            >
                              <Fileupload
                                defaultThumbFile={documentUtility.getThumbnailImagePath(
                                  kycForm.getFieldValue("passportFront")
                                    ?.fileThumbUrl
                                )}
                                defaultFile={
                                  kycForm.getFieldValue("passportFront")
                                    ?.fileUrl
                                }
                                filetype={DocTypes?.PASSPORT_FRONT}
                                fileName={
                                  kycForm.getFieldValue("passportFront")
                                    ?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={true}
                                name={t("KYC_UPLOAD_FRONT_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "passportFront");
                                  //kycForm.setFieldsValue({ passportUpload: value });
                                }}
                                // updateFormValue={(val) => {
                                //   kycForm.setFieldsValue({ passportUpload: val });
                                // }}
                              />
                            </Form.Item> */}
                            {/* **************** OCR File Upload Driving License BACK *********** */}
                            <Form.Item
                              className="floating-label-form-item"
                              name="passportFront"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("PASSPORT_FRONT_UPLOAD_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              {/* ocr */}
                              <OCRFilePreviewUploader
                                filetype={DocTypes.PASSPORT_FRONT}
                                defaultThumbFile={
                                  editAccoutDocs?.passport?.frontDoc
                                    ?.documentPathThumb
                                }
                                defaultFile={
                                  editAccoutDocs?.passport?.frontDoc
                                    ?.documentPath
                                }
                                fileName={
                                  editAccoutDocs?.passport?.frontDoc?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={false}
                                onChange={(newFiles) =>
                                  handleOCRConformFileChange(
                                    newFiles,
                                    "passportFront",
                                    OCRFieldNames.PASSPORT,
                                    DocTypes.PASSPORT_FRONT
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "passportFront",
                                    OCRFieldNames.PASSPORT
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            {/* <Form.Item
                              name="passportBack"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("PASSPORT_BACK_UPLOAD_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                            >
                              <Fileupload
                                defaultThumbFile={documentUtility.getThumbnailImagePath(
                                  kycForm.getFieldValue("passportBack")
                                    ?.fileThumbUrl
                                )}
                                defaultFile={
                                  kycForm.getFieldValue("passportBack")?.fileUrl
                                }
                                filetype={DocTypes?.PASSPORT_BACK}
                                fileName={
                                  kycForm.getFieldValue("passportBack")
                                    ?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={true}
                                name={t("KYC_UPLOAD_BACK_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "passportBack");
                                  //kycForm.setFieldsValue({ passportUpload: value });
                                }}
                                // updateFormValue={(val) => {
                                //   kycForm.setFieldsValue({ passportUpload: val });
                                // }}
                              />
                            </Form.Item> */}
                            {/* **************** OCR File Upload Driving License BACK *********** */}
                            <Form.Item
                              className="floating-label-form-item"
                              name="passportBack"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("PASSPORT_BACK_UPLOAD_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              {/* ocr */}
                              <OCRFilePreviewUploader
                                filetype={DocTypes.PASSPORT_BACK}
                                defaultThumbFile={
                                  editAccoutDocs?.passport?.backDoc
                                    ?.documentPathThumb
                                }
                                defaultFile={
                                  editAccoutDocs?.passport?.backDoc
                                    ?.documentPath
                                }
                                fileName={
                                  editAccoutDocs?.passport?.backDoc?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={false}
                                onChange={(newFiles) =>
                                  handleOCRConformFileChange(
                                    newFiles,
                                    "passportBack",
                                    OCRFieldNames.PASSPORT,
                                    DocTypes.PASSPORT_BACK
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "passportBack",
                                    OCRFieldNames.PASSPORT
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              name="passportNumber"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("ACCOUNT_PASSPORT_NO"),
                                },
                                uniqueDocNumberRule(["passportNumber"]),
                              ]}
                            >
                              <Input
                                value={kycFormValues?.passportNumber}
                                placeholder={t("SIGNUP_KYC_PASSPORT_LIC_LBL")}
                                className="floating-input-basic"
                                maxLength={20}
                                onChange={(e) =>
                                  handleFormChange(
                                    "passportNumber",
                                    e.target.value
                                  )
                                }
                              />
                              <label className="floating-label">
                                {t("ACCOUNT_KYC_DETAIL_PASSPORT_NO")}{" "}
                                <b className="mandate-color">*</b>
                              </label>
                            </Form.Item>

                            <Form.Item
                              name="passportExpiry"
                              rules={[
                                {
                                  required: true,
                                  message: t("ACCOUNT_SELECT_EXP_MSG"),
                                },
                              ]}
                              className="floating-label-form-item"
                            >
                              <DatePicker
                                className="floating-input-basic"
                                style={{ fontSize: "12px" }}
                                value={
                                  kycFormValues?.passportExpiry
                                    ? dayjs(
                                        kycFormValues.passportExpiry,
                                        format
                                      )
                                    : null
                                }
                                disabledDate={disablePastDates}
                                format={format}
                                placeholder={t("SIGNUP_KYC_VAT_REG_EXPIRY_PH")}
                                onChange={
                                  (date, dateString) =>
                                    handleFormChange(
                                      "passportExpiry",
                                      dateString
                                    )
                                  // kycForm.setFieldsValue({
                                  //   passportExpiry: dateString,
                                  // })
                                }
                              />
                              <label className="floating-label">
                                {t("SIGNUP_KYC_VAT_REG_EXPIRY")}{" "}
                                <b className="mandate-color">*</b>
                              </label>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <b>{t("FLEET_DRIVER_NATIONAL_ID")}</b>
                        </Row>
                        {/* National ID */}
                        <Row gutter={[16, 16]}>
                          <Col span={6}>
                            {/* <Form.Item
                              name="nationalIdFront"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("NATIONAL_ID_FRONT_UPLOAD_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                            >
                              <Fileupload
                                defaultThumbFile={documentUtility.getThumbnailImagePath(
                                  kycForm.getFieldValue("nationalIdFront")
                                    ?.fileThumbUrl
                                )}
                                defaultFile={
                                  kycForm.getFieldValue("nationalIdFront")
                                    ?.fileUrl
                                }
                                filetype={DocTypes?.NATIONAL_ID_FRONT}
                                fileName={
                                  kycForm.getFieldValue("nationalIdFront")
                                    ?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={true}
                                name={t("KYC_UPLOAD_FRONT_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "nationalIdFront");
                                  //kycForm.setFieldsValue({ nationalIDUpload: value });
                                }}
                                // updateFormValue={(val) => {
                                //   kycForm.setFieldsValue({ nationalIDUpload: val });
                                // }}
                              />
                            </Form.Item> */}
                            {/* **************** OCR File Upload National ID FRONT *********** */}
                            <Form.Item
                              className="floating-label-form-item"
                              name="nationalIdFront"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("NATIONAL_ID_FRONT_UPLOAD_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              {/* ocr */}
                              <OCRFilePreviewUploader
                                filetype={DocTypes.NATIONAL_ID_FRONT}
                                defaultThumbFile={
                                  editAccoutDocs?.nationalID?.frontDoc
                                    ?.documentPathThumb
                                }
                                defaultFile={
                                  editAccoutDocs?.nationalID?.frontDoc
                                    ?.documentPath
                                }
                                fileName={
                                  editAccoutDocs?.nationalID?.frontDoc?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={false}
                                onChange={(newFiles) =>
                                  handleOCRConformFileChange(
                                    newFiles,
                                    "nationalIdFront",
                                    OCRFieldNames.NATIONAL_ID,
                                    DocTypes.NATIONAL_ID_FRONT
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "nationalIdFront",
                                    OCRFieldNames.NATIONAL_ID
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            {/* <Form.Item
                              name="nationalIdBack"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("NATIONAL_ID_BACK_UPLOAD_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                            >
                              <Fileupload
                                defaultThumbFile={documentUtility.getThumbnailImagePath(
                                  kycForm.getFieldValue("nationalIdBack")
                                    ?.fileThumbUrl
                                )}
                                defaultFile={
                                  kycForm.getFieldValue("nationalIdBack")
                                    ?.fileUrl
                                }
                                filetype={DocTypes?.NATIONAL_ID_BACK}
                                fileName={
                                  kycForm.getFieldValue("nationalIdBack")
                                    ?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={true}
                                name={t("KYC_UPLOAD_BACK_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "nationalIdBack");
                                  //kycForm.setFieldsValue({ nationalIDUpload: value });
                                }}
                                // updateFormValue={(val) => {
                                //   kycForm.setFieldsValue({ nationalIDUpload: val });
                                // }}
                              />
                            </Form.Item> */}
                            {/* **************** OCR File Upload National ID BACK *********** */}
                            <Form.Item
                              className="floating-label-form-item"
                              name="nationalIdBack"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (value?.fileUrl) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        t("NATIONAL_ID_BACK_UPLOAD_REQUIRED")
                                      )
                                    );
                                  },
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              {/* ocr */}
                              <OCRFilePreviewUploader
                                filetype={DocTypes.NATIONAL_ID_BACK}
                                defaultThumbFile={
                                  editAccoutDocs?.nationalID?.backDoc
                                    ?.documentPathThumb
                                }
                                defaultFile={
                                  editAccoutDocs?.nationalID?.backDoc
                                    ?.documentPath
                                }
                                fileName={
                                  editAccoutDocs?.nationalID?.backDoc?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={false}
                                onChange={(newFiles) =>
                                  handleOCRConformFileChange(
                                    newFiles,
                                    "nationalIdBack",
                                    OCRFieldNames.NATIONAL_ID,
                                    DocTypes.NATIONAL_ID_BACK
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "nationalIdBack",
                                    OCRFieldNames.NATIONAL_ID
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              name="nationalIDNumber"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("ACCOUNT_NATIONAL_ID_NO"),
                                },
                                uniqueDocNumberRule("nationalIDNumber"),
                              ]}
                            >
                              <Input
                                value={kycFormValues?.nationalIDNumber}
                                placeholder={t("FLEET_DRIVER_NATIONAL_ID")}
                                className="floating-input-basic"
                                maxLength={20}
                                onChange={(e) =>
                                  handleFormChange(
                                    "nationalIDNumber",
                                    e.target.value
                                  )
                                }
                              />
                              <label className="floating-label">
                                {t("ACCOUNT_KYC_DETAILS_NATIONAL_ID_NO")}{" "}
                                <b className="mandate-color">*</b>
                              </label>
                            </Form.Item>

                            <Form.Item
                              name="nationalIDExpiry"
                              rules={[
                                {
                                  required: true,
                                  message: t("ACCOUNT_SELECT_EXP_MSG"),
                                },
                              ]}
                              className="floating-label-form-item"
                            >
                              <DatePicker
                                className="floating-input-basic"
                                style={{ fontSize: "12px" }}
                                value={
                                  kycFormValues?.nationalIDExpiry
                                    ? dayjs(
                                        kycFormValues.nationalIDExpiry,
                                        format
                                      )
                                    : null
                                }
                                disabledDate={disablePastDates}
                                format={format}
                                placeholder={t("SIGNUP_KYC_VAT_REG_EXPIRY_PH")}
                                onChange={
                                  (date, dateString) =>
                                    handleFormChange(
                                      "nationalIDExpiry",
                                      dateString
                                    )
                                  //kycForm.setFieldsValue({ vatExpiry: dateString })
                                }
                              />
                              <label className="floating-label">
                                {t("SIGNUP_KYC_VAT_REG_EXPIRY")}{" "}
                                <b className="mandate-color">*</b>
                              </label>
                            </Form.Item>
                          </Col>
                        </Row>
                        <b>{t("FLEET_DRIVER_VISA")}</b>
                        {/* Visa */}
                        <Row gutter={[16, 16]}>
                          {visa?.map((data, index) => (
                            <>
                              {/* {data.frontDoc && data.frontDoc !== null && ( */}

                              <Col span={12}>
                                {/* <Form.Item
                                  name={["visa", index, "frontDoc"]}
                                  // rules={[
                                  //   {
                                  //     validator: (_, value) => {

                                  //       if (value?.fileName) {
                                  //         return Promise.resolve();
                                  //       }
                                  //       return Promise.reject(new Error(t("VISA_DOC_UPLOAD_REQUIRED")));
                                  //     },
                                  //   },
                                  // ]}
                                  // rules={[{ required: true, message: 'Please upload visa document!' }]}
                                >
                                  <Fileupload
                                    filetype={DocTypes.VISA_FRONT}
                                    defaultThumbFile={
                                      data?.frontDoc?.documentPathThumb
                                    }
                                    defaultFile={data?.frontDoc?.documentPath}
                                    fileName={data?.frontDoc?.fileName}
                                    entityId={""}
                                    entityType={EntityTypes.SUPPLIER}
                                    accessFile={false}
                                    onChange={(value) => {
                                      handleVisaDocumentChange(value, index, 0);
                                    }}

                                    //updateFormValue={(val)=>{ addDriverForm.setFieldsValue({ visaFront: val })}}
                                  />
                                </Form.Item> */}
                                {/* Handle VISA OCR */}
                                <Form.Item
                                  className="floating-label-form-item"
                                  valuePropName="value"
                                  getValueFromEvent={(e) => {
                                    // if your component emits [ { file, fileThumbUrl } ]
                                    if (Array.isArray(e) && e.length > 0) {
                                      return {
                                        // File: e[0].file,
                                        // FileThumbURL: e[0].fileThumbUrl,
                                      };
                                    }
                                    return e;
                                  }}
                                >
                                  <OCRFilePreviewUploader
                                    filetype={DocTypes.VISA_FRONT}
                                    defaultThumbFile={
                                      data.frontDoc?.documentPathThumb
                                    }
                                    defaultFile={data.frontDoc?.documentPath}
                                    fileName={data.frontDoc?.fileName}
                                    entityId={""}
                                    entityType={EntityTypes.SUPPLIER}
                                    accessFile={false}
                                    name={t("KYC_UPLOAD_BACK_LBL")}
                                    onChange={(newFiles) =>
                                      handleOCRConformFileChange(
                                        newFiles,
                                        "visa",
                                        OCRFieldNames.VISA,
                                        DocTypes.VISA_FRONT,
                                        index
                                      )
                                    }
                                    onDelete={() =>
                                      handleVisaDeleteFileUpload(index)
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              {/* )} */}

                              <Col span={12}>
                                <Form.Item
                                  //name={`visaNumber-${index}`}
                                  name={["visa", index, "documentNumber"]}
                                  className="floating-label-form-item"
                                  rules={[
                                    {
                                      pattern: new RegExp("^[a-zA-Z0-9-]+$"),
                                      message: t("CORRECT_FORMAT_REQUIRED"),
                                    },
                                    uniqueDocNumberRule(["visa", index, "documentNumber"])
                                  ]}
                                >
                                  <Input
                                    value={data?.documentNumber}
                                    placeholder={t(
                                      "SIGNUP_KYC_TRADE_LIC_NUM_PH"
                                    )}
                                    className="floating-input-basic"
                                    maxLength={25}
                                    onChange={(e) => {
                                      handleVisa(
                                        { documentNumber: e.target.value },
                                        index
                                      );
                                    }}
                                  />
                                  <label className="floating-label">
                                    {t("ACCOUNT_KYC_DETAIL_VISA_NO")}{" "}
                                    <b className="mandate-color"></b>
                                  </label>
                                </Form.Item>

                                <Form.Item
                                  // name={`visaExpiry-${index}`}
                                  name={["visa", index, "expiryDate"]}
                                  // rules={[
                                  //   {
                                  //     required: true,
                                  //     message: t("EXPIRY_DATE_REQUIRED"),
                                  //   },
                                  // ]}
                                  className="floating-label-form-item"
                                >
                                  <DatePicker
                                    // format="DD/MM/YYYY"
                                    className="floating-input-basic"
                                    style={{ fontSize: "12px" }}
                                    // value={
                                    //   data?.visa?.[index]?.expiryDate
                                    //   ? dayjs(data?.visa?.[index]?.expiryDate)
                                    //     : null || ""
                                    // }
                                    //****** */ Before OCR *******
                                    // value={
                                    //   data?.expiryDate
                                    //     ? dayjs(data?.expiryDate, format)
                                    //     : null
                                    // }
                                    // ****** After OCR Implemented ******
                                    value={
                                      data?.expiryDate
                                        ? dayjs(
                                            data.expiryDate,
                                            "YYYY-MM-DD"
                                          ).isValid()
                                          ? dayjs(data.expiryDate, "YYYY-MM-DD")
                                          : dayjs(data.expiryDate, "DD/MM/YYYY")
                                        : null
                                    }
                                    disabledDate={disablePastDates}
                                    format={format}
                                    placeholder={t(
                                      "SIGNUP_KYC_VAT_REG_EXPIRY_PH"
                                    )}
                                    onChange={
                                      (date, dateString) => {
                                        handleVisa(
                                          { expiryDate: dateString },
                                          index
                                        );
                                      }
                                      // kycForm.setFieldsValue({
                                      //   visaExpiry: dateString,
                                      // })
                                    }
                                  />
                                  <label className="floating-label">
                                    {t("SIGNUP_KYC_VAT_REG_EXPIRY")}{" "}
                                    <b className="mandate-color"></b>
                                  </label>
                                </Form.Item>

                                <Form.Item
                                  className="floating-label-form-item"
                                  name={["visa", index, "issuingCountry"]}
                                  // rules={[{ required: true, message: t("ISSUE_COUNTRY_VALIDATION") }]}
                                >
                                  <Select
                                    name="issuingCountry"
                                    className="floating-selectt"
                                    options={countryOptions}
                                    showSearch
                                    placeholder={t(
                                      "ACCOUNT_SELECT_ISSUING_COUNTRY_MSG"
                                    )}
                                    value={data?.issuingCountry}
                                    fieldNames={{
                                      label: "name",
                                      value: "name",
                                    }}
                                    onChange={(value) => {
                                      //   addDriverForm.setFieldsValue({
                                      //     ["visa_" + index + "_issuingCountry"]: value,
                                      //   });
                                      //   handleFormChange("visa_" + index + "_issuingCountry", value);
                                      handleVisa(
                                        { issuingCountry: value },
                                        index
                                      );
                                    }}
                                    filterOption={(input, option) =>
                                      option.name
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                  />
                                  <label className="floating-label">
                                    {t("ACCOUNT_ISSUNING_COUNTRY")}{" "}
                                    <span></span>
                                  </label>
                                </Form.Item>

                                <div
                                  style={{
                                    marginLeft: "10px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  {visa.length > 1 && (
                                    <Button
                                      type="link"
                                      danger
                                      icon={<DeleteOutlined />}
                                      onClick={() => removeVisa(index)}
                                    ></Button>
                                  )}
                                </div>
                              </Col>
                              {/* {index == 0 &&   } */}
                            </>
                          ))}
                          {!checkIsInternalSourcing(user?.userRole) && (
                            <Col span={24}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <Button
                                  type="secondary"
                                  icon={<PlusOutlined />}
                                  style={{ color: "var(--attention-orange)" }}
                                  onClick={addVisa}
                                  disabled={visa?.length >= 5}
                                >
                                  {t("ACCOUNT_ADD_DOC")}
                                </Button>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </Form>
                    </Card>
                  )
                )}
              </div>
            </>
          )}

          <Modal
            className="change-mobile-modal"
            title={
              <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                {t("ACCOUNT_CHANGE_MOB")}
              </div>
            }
            open={isChangeMobileVisible}
            // onOk={onRequestOTP}
            onCancel={handleMobileModalCancel}
            footer={false}
          >
            <div
              style={{
                height: "1px",
                backgroundColor: "var(--surface-3, #e0e0e0)",
                marginBottom: "16px",
              }}
            ></div>
            {(isOldOTPVerified && (
              <Row gutter={16}>
                <Col span={12} className="change-mobileNo-title">
                  {t("ACCOUNT_ENTER_OTP")}
                </Col>
                <Col className="send-mobile" span={12}>
                  {t("SEND_TO_KEY")} +{" "}
                  {accountDetails?.countryCode + accountDetails?.mobileNo}
                </Col>
              </Row>
            )) ||
              (isOTPVerified && (
                <span className="change-mobileNo-title">
                  {t("ACCOUNT_OTP_VERIFICATION_MSG")}
                </span>
              )) ||
              (isNewOTPRequested && (
                <span className="change-mobileNo-title">
                  {t("ACCOUNT_OTP_CHANGE_MOB_MSG")}{" "}
                  <span style={{ display: "flex", justifyContent: "center" }}>
                    {MobileChangeForm.getFieldValue("mobileNumber")}
                  </span>
                </span>
              ))}
            <Form form={MobileChangeForm}>
              {(isOldOTPVerified && (
                <div className="otp-input">
                  <Form.Item
                    name="otpNumber"
                    rules={[
                      { required: true, message: t("OTP_REQUIRED") },
                      {
                        pattern: /^[0-9]{4}$/, // Regex to match exactly 4 digits
                        message: t("OTP_VALIDATION_MSG"),
                      },
                    ]}
                  >
                    <Input.OTP
                      style={{ width: "150px", height: "48px" }}
                      className="otp-input"
                      name="otpNumber"
                      length={4}
                      onChange={(e) => setIsOldOtp(e)}
                    />
                  </Form.Item>
                </div>
              )) ||
                (isOTPVerified && (
                  <>
                    <Row justify={"center"} style={{ marginTop: "2rem" }}>
                      <Col span={8} style={{ paddingRight: "3px" }}>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: t("COUNTRY_CODE_REQUIRED"),
                            },
                          ]}
                          name="countryCode"
                          className="floating-label-form-item"
                        >
                          <Select
                            showSearch
                            className="floating-select country-code-select"
                            popupClassName="country-code-popup"
                            value={MobileChangeForm?.getFieldValue(
                              "countryCode"
                            )}
                            // placeholder="+355"
                            loading={mobileCountryCodeLoader}
                            // options={MobileCountryCodeList}
                            options={MobileCountryCodeList.map((item) => ({
                              ...item,
                              key: `${item.phone_code}-${
                                item.country_code
                              }-${item.name.replace(/\s+/g, "")}`, // Unique key
                            }))}
                            // value={accountDetails?.countryCode}
                            onChange={(e, option) =>
                              handleCountryCodeFormChange(
                                "countryCode",
                                e,
                                option
                              )
                            }
                            fieldNames={{
                              label: "label",
                              value: "phone_code",
                            }}
                            filterOption={(input, option) =>
                              option?.searchKey?.includes(input.toLowerCase())
                            }
                            style={{ width: "94", height: "48px" }}
                          />
                          <label>
                            <Text
                              className="floating-label"
                              style={{ width: "8vw" }}
                              ellipsis={{ tooltip: true }}
                            >
                              {t("FORGOT_LBL_COUNTRY_CODE")}{" "}
                              <b className="mandate-color">*</b>
                            </Text>
                          </label>
                        </Form.Item>
                      </Col>
                      <Col span={16}>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: t("MOBILE_NO_REQUIRED"),
                            },
                            {
                              pattern: /^[0-9]*$/,
                              message: t("MOBILE_NO_VALIDATION_REQUIRED"),
                            },
                            {
                              validator: (rule, value) =>
                                validateMobileNumber(
                                  MobileChangeForm?.getFieldValue(
                                    "countryCode"
                                  ),
                                  value,
                                  t
                                ),
                            },
                          ]}
                          name="mobileNumber"
                          className="floating-label-form-item"
                        >
                          <Input
                            placeholder={t("FORGOT_PH_MOBILE_NO")}
                            style={{ width: "330px", height: "48px" }}
                            className="floating-input-basic"
                            onChange={(e) =>
                              MobileChangeForm.setFieldValue(
                                "mobileNumber",
                                e.target.value
                              )
                            }
                            minLength={minLength}
                            maxLength={maxLength}
                          />
                          <label className="floating-label">
                            {t("FORGOT_LBL_MOBILE_NO")}{" "}
                            <b className="mandate-color">*</b>
                          </label>
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )) ||
                (isOTPRequested && (
                  <>
                    <Row justify={"center"}>
                      <Col>
                        <br />
                        <div className="four-digit">
                          {t("ENTER_FOUR_DIGIT_OTP")}
                        </div>
                      </Col>
                      <Col></Col>
                    </Row>
                    <Row justify={"center"}>
                      <Col span={24}>
                        {/* <Form textAlign='center' form={confirmMobileForm}> */}
                        <Form textAlign="center">
                          <Form.Item
                            name="newOtpNumber"
                            rules={[
                              { required: true, message: t("OTP_REQUIRED") },
                              {
                                pattern: /^[0-9]{4}$/, // Regex to match exactly 4 digits
                                message: t("OTP_VALIDATION_MSG"),
                              },
                            ]}
                          >
                            <div className="otp-input">
                              <Input.OTP
                                style={{ width: "150px", height: "48px" }}
                                length={4}
                                onChange={(e) =>
                                  MobileChangeForm.setFieldValue(
                                    "newOtpNumber",
                                    e
                                  )
                                }
                              />
                            </div>
                          </Form.Item>
                        </Form>
                      </Col>
                      <Col style={{ textAlign: "end" }}>
                        {isOTPRequested && (
                          <span
                            onClick={onResendOTP}
                            className={
                              timer === 0 ? "resend-otp" : "resend-otp-timer"
                            }
                          >
                            {timer === 0
                              ? "Resend OTP"
                              : `Resend OTP in ${timer}s`}
                          </span>
                        )}
                      </Col>
                    </Row>
                  </>
                ))}
            </Form>

            <div className="mobile-change-footer">
              <Button
                className="mobile-change-button"
                key="cancel"
                onClick={handleMobileModalCancel}
              >
                {t("ACCOUNT_CANCEL")}
              </Button>
              <Button
                className="mobile-change-button"
                loading={emailOtpLoader}
                key="submit"
                type="primary"
                onClick={
                  isOldOTPVerified
                    ? verifyOTPDetails
                    : isOTPVerified
                    ? onRequestOTP
                    : newMobileChangeSuccess
                }
              >
                {t("SIGNUP_KYC_SUBMIT_BTN")}
              </Button>
            </div>
          </Modal>

          <Modal
            className="change-mobile-modal"
            title={
              <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                {t("CHANGE_EMAIL_ADDRESS_KEY")}
              </div>
            }
            open={showEmail}
            // onOk={onRequestOTP}
            onCancel={handleEmailModalCancel}
            footer={false}
          >
            <div
              style={{
                height: "1px",
                backgroundColor: "var(--surface-3, #e0e0e0)",
                marginBottom: "16px",
              }}
            ></div>
            {(isOldOTPVerified && (
              <Row gutter={16}>
                <Col span={12} className="change-mobileNo-title">
                  {t("ENTER_OTP_KEY")}
                </Col>
                <Col className="send-mobile" span={12}>
                  {t("SEND_TO_KEY")} {accountDetails?.email}
                </Col>
              </Row>
            )) ||
              (isOldOTPVerified && (
                <span className="change-mobileNo-title">
                  {t("ACCOUNT_OTP_EMAIL_VERIFICATION_MSG")}
                </span>
              )) ||
              (isOldOTPVerified && (
                <span className="change-mobileNo-title">
                  {t("ACCOUNT_OTP_CHANGE_EMAIL_MSG")}{" "}
                  <span style={{ display: "flex", justifyContent: "center" }}>
                    {MobileChangeForm.getFieldValue("mobileNumber")}
                  </span>
                </span>
              ))}
            <Form form={emailChangeForm}>
              {(isOldOTPVerified && (
                <div className="otp-input">
                  <Form.Item
                    name="otpNumber"
                    rules={[
                      { required: true, message: t("OTP_REQUIRED") },
                      {
                        pattern: /^[0-9]{4}$/, // Regex to match exactly 4 digits
                        message: t("OTP_VALIDATION_MSG"),
                      },
                    ]}
                  >
                    <Input.OTP
                      style={{ width: "150px", height: "48px" }}
                      className="otp-input"
                      name="otpNumber"
                      length={4}
                      onChange={(e) => setIsOldOtp(e)}
                    />
                  </Form.Item>
                </div>
              )) ||
                (isOTPVerified && (
                  <>
                    <Row justify={"center"} style={{ marginTop: "2rem" }}>
                      <Form.Item
                        name="emailId"
                        className="floating-label-form-item"
                        style={{ width: "100%" }}
                        rules={[
                          {
                            //  validator: validateEmail('emailId')
                            required: true,
                            message: t("EMAIL_REQUIRED"),
                          },
                          {
                            type: "email", // Built-in email type validation
                            message: t("EMAIL_VALIDATION_MSG"),
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("SIGNUP_BASIC_INFO_EMAIL_PH")}
                          className="floating-input-basic"
                          onChange={(e) => {
                            emailChangeForm.setFieldsValue({
                              emailId: e.target.value,
                            });
                            emailChangeForm.validateFields(["emailId"]);
                          }}
                        />
                        <label className="floating-label">
                          {t("SIGNUP_BASIC_INFO_EMAIL")}
                        </label>
                      </Form.Item>
                    </Row>
                  </>
                )) ||
                (isOTPRequested && (
                  <>
                    <Row justify={"center"}>
                      <Col>
                        <br />
                        <div className="four-digit">
                          {t("ACCOUNT_ENTER_OTP")}
                        </div>
                      </Col>
                      <Col></Col>
                    </Row>
                    <Row justify={"center"}>
                      <Col span={24}>
                        {/* <Form textAlign='center' form={confirmMobileForm}> */}
                        <Form textAlign="center">
                          <Form.Item
                            name="newOtpNumber"
                            rules={[
                              { required: true, message: t("OTP_REQUIRED") },
                              {
                                pattern: /^[0-9]{4}$/, // Regex to match exactly 4 digits
                                message: t("OTP_VALIDATION_MSG"),
                              },
                            ]}
                          >
                            <div className="otp-input">
                              <Input.OTP
                                style={{ width: "150px", height: "48px" }}
                                length={4}
                                onChange={(e) => {
                                  emailChangeForm.setFieldValue(
                                    "newOtpNumber",
                                    e
                                  );
                                  emailChangeForm?.validateFields([
                                    "newOtpNumber",
                                  ]);
                                }}
                              />
                            </div>
                          </Form.Item>
                        </Form>
                      </Col>
                      <Col style={{ textAlign: "end" }}>
                        {isOTPRequested && (
                          <span
                            onClick={onResendOTP}
                            className={
                              timer === 0 ? "resend-otp" : "resend-otp-timer"
                            }
                          >
                            {timer === 0
                              ? t("RESEND_OTP_KEY")
                              : `${t("RESEND_OTP_IN_KEY")} ${timer}s`}
                          </span>
                        )}
                      </Col>
                    </Row>
                  </>
                ))}
            </Form>

            <div className="mobile-change-footer">
              <Button
                className="mobile-change-button"
                key="cancel"
                onClick={handleEmailModalCancel}
              >
                {t("COMMON_CANCEL_BTN")}
              </Button>
              <Button
                className="mobile-change-button"
                key="submit"
                type="primary"
                loading={otpLoader} // Dynamically toggle the loader
                onClick={
                  isOldOTPVerified
                    ? verifyEmailOTPDetails
                    : isOTPVerified
                    ? onRequestEmailOTP
                    : newEmailIDChangeSuccess
                }
              >
                {t("SIGNUP_KYC_SUBMIT_BTN")}
              </Button>
            </div>
          </Modal>

          <Modal
            className="change-mobile-modal"
            title={
              <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                {t("ACCOUNT_CHANGE_EMAIL_ADD")}
              </div>
            }
            open={addEmailModal}
            onCancel={() => setaddEmailModal(false)}
            footer={false}
          >
            {" "}
            <div
              style={{
                height: "1px",
                backgroundColor: "var(--surface-3, #e0e0e0)",
                marginBottom: "16px",
              }}
            ></div>
            <>
              <Form form={emailChangeForm}>
                {!isAddEmailOtpVerified ? (
                  <Row justify={"center"} style={{ marginTop: "2rem" }}>
                    <Form.Item
                      name="emailId"
                      className="floating-label-form-item"
                      style={{ width: "100%" }}
                      rules={[
                        {
                          //  validator: validateEmail('emailId')
                          required: true,
                          message: t("EMAIL_REQUIRED"),
                        },
                        {
                          type: "email", // Built-in email type validation
                          message: t("EMAIL_VALIDATION_MSG"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={t("SIGNUP_BASIC_INFO_EMAIL_PH")}
                        className="floating-input-basic"
                        onChange={(e) => {
                          emailChangeForm.setFieldsValue({
                            emailId: e.target.value,
                          });
                          emailChangeForm.validateFields(["emailId"]);
                        }}
                      />
                      <label className="floating-label">
                        {t("SIGNUP_BASIC_INFO_EMAIL")}
                      </label>
                    </Form.Item>
                  </Row>
                ) : (
                  <>
                    <Row justify={"center"}>
                      <Col>
                        <br />
                        <div className="four-digit">
                          {t("ACCOUNT_ENTER_OTP")}
                        </div>
                      </Col>
                      <Col></Col>
                    </Row>
                    <Row justify={"center"}>
                      <Col span={24}>
                        {/* <Form textAlign='center' form={confirmMobileForm}> */}
                        <Form textAlign="center">
                          <Form.Item
                            name="newOtpNumber"
                            rules={[
                              { required: true, message: t("OTP_REQUIRED") },
                              {
                                pattern: /^[0-9]{4}$/, // Regex to match exactly 4 digits
                                message: t("OTP_VALIDATION_MSG"),
                              },
                            ]}
                          >
                            <div className="otp-input">
                              <Input.OTP
                                style={{ width: "150px", height: "48px" }}
                                length={4}
                                onChange={(e) => {
                                  emailChangeForm.setFieldValue(
                                    "newOtpNumber",
                                    e
                                  );
                                  emailChangeForm?.validateFields([
                                    "newOtpNumber",
                                  ]);
                                }}
                              />
                            </div>
                          </Form.Item>
                        </Form>
                      </Col>
                      <Col style={{ textAlign: "end" }}>
                        {isOTPRequested && (
                          <span
                            onClick={onResendOTP}
                            className={
                              timer === 0 ? "resend-otp" : "resend-otp-timer"
                            }
                          >
                            {timer === 0
                              ? "Resend OTP"
                              : `Resend OTP in ${timer}s`}
                          </span>
                        )}
                      </Col>
                    </Row>
                  </>
                )}
              </Form>
              <div className="mobile-change-footer">
                <Button
                  className="mobile-change-button"
                  key="cancel"
                  onClick={() => setaddEmailModal(false)}
                >
                  {t("COMMON_CANCEL_BTN")}
                </Button>
                <Button
                  className="mobile-change-button"
                  key="submit"
                  type="primary"
                  loading={addEmailOtpLoader}
                  onClick={
                    !isAddEmailOtpVerified
                      ? onRequestEmailOTP
                      : newEmailIDChangeSuccess
                  }
                >
                  {t("SIGNUP_KYC_SUBMIT_BTN")}
                </Button>
              </div>
            </>
          </Modal>

          <Modal
            className="change-mobile-modal"
            title={
              <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                {t("ACCOUNT_UPLOAD_PROFILE_PIC")}
              </div>
            }
            open={isUploadImage}
            onCancel={() => setIsUploadImage(false)}
            footer={false}
          >
            <br />

            <Form form={uploadImageForm} name="uploadImageForm">
              <Form.Item
                name="uploadImage"
                className="floating-label-form-item"
                rules={[
                  { required: true, message: t("UPLOAD_PROFILE_PIC_MSG") },
                ]}
              >
                <Fileupload
                  defaultThumbFile={documentUtility.getThumbnailImagePath(
                    uploadImageForm.getFieldValue("uploadImage")?.fileThumbUrl
                  )}
                  defaultFile={
                    uploadImageForm.getFieldValue("uploadImage")?.fileUrl
                  }
                  filetype={DocTypes?.PROFILE_PIC}
                  fileName={
                    uploadImageForm.getFieldValue("uploadImage")?.fileName
                  }
                  entityId=""
                  entityType={EntityTypes.SUPPLIER}
                  accessFile={true}
                  name={t("KYC_UPLOAD_FRONT_LBL")}
                  onChange={(value) => {
                    onProfilePictureUpload(value, "uploadImage");
                    //kycForm.setFieldsValue({ licenceFront: value });
                  }}
                  // updateFormValue={(val)=>{ kycForm.setFieldsValue({ licenceFront: val })}}
                />
              </Form.Item>
            </Form>

            <div className="mobile-change-footer">
              <Button
                className="mobile-change-button"
                key="cancel"
                disabled={imageUploadLoader}
                onClick={() => setIsUploadImage(false)}
              >
                {t("COMMON_CANCEL_BTN")}
              </Button>
              <Button
                className="mobile-change-button"
                loading={imageUploadLoader}
                key="submit"
                type="primary"
                onClick={handleUploadProfile}
              >
                {t("SIGNUP_KYC_SUBMIT_BTN")}
              </Button>
            </div>
          </Modal>
        </div>
      )}

      {/* **************Uploading OCR Loading *****************/}
      <Modal
        open={isUploadingPopupVisible}
        footer={null}
        closable={false}
        // onCancel={() => setIsUploadingPopupVisible(false)}
        centered
        width={352}
        style={{
          textAlign: "center",
          padding: "32px 16px",
          zIndex: "2000000 !important",
          position: "relative",
        }}
      >
        <h3
          style={{
            fontWeight: "600",
            fontSize: "18px",
            lineHeight: "1.5",
            margin: 0,
          }}
        >
          {t("OCR_MODAL_UPLOADING_PROCESSING_DOC")}
        </h3>
        <div style={{ margin: "12px 0" }}>
          <img
            // src={logo}
            src={fileSearchGif}
            alt="File Search"
            style={{ width: 112, height: 112 }}
          ></img>
        </div>

        <p
          style={{
            fontWeight: "500",
            fontSize: "14px",
            margin: 0,
            color: "var(--text-muted, #2C3A4BE5)",
          }}
        >
          {uploadState.status}
        </p>
        <p
          style={{
            color: "var(--text, #394452)",
            fontSize: "12px",
            marginTop: "8px",
            marginBottom: 0,
            color: "var(--text-muted, #394452CC)",
          }}
        >
          {uploadState.description}
        </p>
      </Modal>
    </>
  );
};

export default Account;
